const BLOOM_CURATED = {
	"updated_at": "2026-11-04T13:17:15.604Z",
	"total_collections": 15,
	"total_items": 238,
	"products": {
		"106": {
			"title": "106 Chromatic Rose",
			"brand": "Bon Parfumeur",
			"price": 115,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/106_442ec6b9-c82e-459c-9c47-dbeb3c3a6434_500x.jpg?v=1779898934",
			"gender": "Female"
		},
		"202": {
			"title": "202 Frutti Solari",
			"brand": "Bon Parfumeur",
			"price": 60,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/202_500x.jpg?v=1779904762",
			"gender": "Unisex"
		},
		"602": {
			"title": "602 Bois Narcotique",
			"brand": "Bon Parfumeur",
			"price": 115,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/602_500x.jpg?v=1779906219",
			"gender": "Male"
		},
		"701": {
			"title": "701 Eau de Cyprès",
			"brand": "Bon Parfumeur",
			"price": 55,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/701_500x.jpg?v=1779907206",
			"gender": "Unisex"
		},
		"902": {
			"title": "902 Hazy Spice",
			"brand": "Bon Parfumeur",
			"price": 115,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/902_500x.jpg?v=1779907944",
			"gender": "Unisex"
		},
		"wind-from-mount-kailash": {
			"title": "Wind from mount Kailash",
			"brand": "Anna Zworykina",
			"price": 95,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/Wind_500x.jpg?v=1777369067",
			"gender": "Unisex"
		},
		"like-this": {
			"title": "Like This",
			"brand": "Etat Libre d'Orange",
			"price": 155,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/Like_This_100_ml_a9235816-2a92-4034-84e7-fb01613a4ed8_500x.jpg?v=1625875991",
			"gender": "Unisex"
		},
		"nuit-de-baklite": {
			"title": "Nuit de Bakélite",
			"brand": "Naomi Goodsir",
			"price": 170,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/NGP_NUIT_DE_BAKELITE_2019_bloom_500x.png?v=1589662126",
			"gender": "Unisex"
		},
		"bois-dascse": {
			"title": "Bois d’Ascese",
			"brand": "Naomi Goodsir",
			"price": 170,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/NGP_BOIS_D_ASCESE_2019_500x.png?v=1604928347",
			"gender": "Unisex"
		},
		"dark-side-of-the-goddess": {
			"title": "Dark Side of the Goddess",
			"brand": "Anna Zworykina",
			"price": 95,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/anna_dark_500x.jpg?v=1777360775",
			"gender": "Unisex"
		},
		"ombre-indigo": {
			"title": "Ombre Indigo",
			"brand": "Olfactive Studio",
			"price": 140,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/oi_500x.jpg?v=1592594092",
			"gender": "Unisex"
		},
		"fat-electrician": {
			"title": "Fat Electrician",
			"brand": "Etat Libre d'Orange",
			"price": 155,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/fat_electrician_etat_libre_dorange_24bad1d2-5885-4990-84a1-f9f019b0262a_500x.jpg?v=1625875929",
			"gender": "Unisex"
		},
		"vanillaco-sweet-shades-in-perfume-pack": {
			"title": "Vanilla&Co. Sweet Shades in Perfume Pack",
			"brand": "Bloom Sample Packs",
			"price": 59,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/modernclassic_vanilla_500x.jpg?v=1589665542",
			"gender": "Unisex"
		},
		"chambre-noire": {
			"title": "Chambre Noire",
			"brand": "Olfactive Studio",
			"price": 140,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/chambre_noir_olfactive_studio_500x.jpg?v=1589660899",
			"gender": "Unisex"
		},
		"lumire-blanche": {
			"title": "Lumiere Blanche",
			"brand": "Olfactive Studio",
			"price": 140,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/lb_500x.jpg?v=1589662069",
			"gender": "Unisex"
		},
		"vi-et-armis": {
			"title": "Vi et Armis",
			"brand": "Beaufort",
			"price": 125,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/BeauFort_London_Vi_et_Armis_Bloom_500x.jpg?v=1623765299",
			"gender": "Unisex"
		},
		"poudre-de-riz": {
			"title": "Poudre de Riz",
			"brand": "Pierre Guillaume Black Collection",
			"price": 140,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/poudre_de_riz_huiteme_art_100_ml_500x.jpg?v=1589662188",
			"gender": "Female"
		},
		"the-architects-club": {
			"title": "The Architects Club",
			"brand": "Arquiste",
			"price": 195,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/Arquiste_architects_club_500x.jpg?v=1589665520",
			"gender": "Unisex"
		},
		"aqueous-florals-sample-pack": {
			"title": "Aqueous Florals Sample Pack",
			"brand": "Bloom Sample Packs",
			"price": 29,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/aqueous_floral_perfumes_samples_500x.jpg?v=1589660852",
			"gender": "Female"
		},
		"pg16-jardins-de-kerylos": {
			"title": "PG16 Jardins de Kérylos",
			"brand": "Pierre Guillaume - Parfumerie Générale",
			"price": 140,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/PG16_Jardin_de_Kerylos_500x.jpg?v=1589662162",
			"gender": "Female"
		},
		"rouge-avignon": {
			"title": "Rouge Avignon",
			"brand": "Phaedon Paris",
			"price": 130,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/PHAEDON_ROUGE_AVIGNON_20201_500x.jpg?v=1589665446",
			"gender": "Unisex"
		},
		"you-or-someone-like-you": {
			"title": "You or Someone Like You",
			"brand": "Etat Libre d'Orange",
			"price": 155,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/You_Or_Someone_Like_You_100_ml_1_946b1c29-12a6-444f-9b02-7c047eded2ab_500x.jpg?v=1625876471",
			"gender": "Unisex"
		},
		"entre-ciel-et-mer": {
			"title": "Entre Ciel et Mer",
			"brand": "Pierre Guillaume Cruise/Croisiere",
			"price": 144,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/ENTRE_CIEL_ET_MER-100ML_500x.jpg?v=1589660953",
			"gender": "Unisex"
		},
		"ambroxan-pack": {
			"title": "Ambroxan Pack",
			"brand": "Bloom Sample Packs",
			"price": 25,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/ambroxan_perfume_sample_pack_500x.jpg?v=1589660843",
			"gender": "Unisex"
		},
		"fathom-v": {
			"title": "Fathom V",
			"brand": "Beaufort",
			"price": 125,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/medium_new_beaufort_fathom_5_bloom_500x.jpg?v=1623765447",
			"gender": "Unisex"
		},
		"monsieur": {
			"title": "Monsieur",
			"brand": "Pierre Guillaume Black Collection",
			"price": 140,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/Parfumerie_black_Monsieur_500x.png?v=1589662103",
			"gender": "Male"
		},
		"cuirs": {
			"title": "CUIRS",
			"brand": "CARNER",
			"price": 150,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/Carner_CUIRS_500x.jpg?v=1589660934",
			"gender": "Unisex"
		},
		"iris-cendr": {
			"title": "Iris Cendré",
			"brand": "Naomi Goodsir",
			"price": 170,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/iris_cendre_naomi_goodsir_500x.jpg?v=1589662020",
			"gender": "Unisex"
		},
		"north": {
			"title": "North",
			"brand": "Mendittorosa",
			"price": 180,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/medium_North_1__white_500x.jpg?v=1589662124",
			"gender": "Unisex"
		},
		"tobacco-tuberose": {
			"title": "Tobacco Tuberose",
			"brand": "Anna Zworykina",
			"price": 95,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/anna_tobaco_500x.jpg?v=1777368741",
			"gender": "Unisex"
		},
		"volcano": {
			"title": "Volcano",
			"brand": "CARNER",
			"price": 225,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/volcano_carner_500x.jpg?v=1589665551",
			"gender": "Unisex"
		},
		"coeur-de-noir-1": {
			"title": "Coeur de Noir",
			"brand": "Beaufort",
			"price": 125,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/medium_BeauFort_London_Coeur_de_Noir_Bloom_500x.jpg?v=1623765413",
			"gender": "Unisex"
		},
		"remarkable-people": {
			"title": "Remarkable People",
			"brand": "Etat Libre d'Orange",
			"price": 155,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/Remarkable-People-100-ml_5d373565-c3da-46de-8617-af6d94a80a6b_500x.jpg?v=1625876102",
			"gender": "Unisex"
		},
		"sydney-rock-pool": {
			"title": "Sydney Rock Pool",
			"brand": "Arquiste",
			"price": 195,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/sydney_rockpool_arquiste_c1df3be0-2ab0-4f24-b272-33798ef6b37d_500x.jpg?v=1625876155",
			"gender": "Unisex"
		},
		"rake-and-ruin": {
			"title": "Rake and Ruin",
			"brand": "Beaufort",
			"price": 125,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/rake_ruin_beaufort1_500x.jpg?v=1623765138",
			"gender": "Unisex"
		},
		"venetian-red": {
			"title": "Venetian Red",
			"brand": "Anna Zworykina",
			"price": 95,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/Vred_500x.jpg?v=1777368895",
			"gender": "Unisex"
		},
		"rose-de-taif": {
			"title": "Rose de Taif",
			"brand": "Perris Monte Carlo",
			"price": 160,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/Black-Rose-de-Taif_100_ml_8c8c6a2d-afcb-44f3-82e6-21fc28998642_500x.jpg?v=1625876109",
			"gender": "Unisex"
		},
		"no-89": {
			"title": "No. 89",
			"brand": "Floris",
			"price": 100,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/floris_89_500x.jpg?v=1787327688",
			"gender": "Unisex"
		},
		"500-years": {
			"title": "500 years",
			"brand": "Etat Libre d'Orange",
			"price": 240,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/500-Years-100-ml-01_500x.jpg?v=1625873538",
			"gender": "Unisex"
		},
		"ta-if": {
			"title": "Ta’if",
			"brand": "Ormonde Jayne",
			"price": 235,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/ta-if-88ml-front_1020x1530_1_500x.jpg?v=1711456555",
			"gender": "Unisex"
		},
		"qi": {
			"title": "QI",
			"brand": "Ormonde Jayne",
			"price": 295,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/qi-intensivo-88ml-front_1020x1530_1_500x.jpg?v=1711455337",
			"gender": "Unisex"
		},
		"bohemian": {
			"title": "Bohemian",
			"brand": "SweDoft",
			"price": 185,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/BOHEMIAN_cd233cae-ece3-46c3-8b18-bd8d33a2cb45_500x.jpg?v=1632582931",
			"gender": "Unisex"
		},
		"old-library-dreams": {
			"title": "Old Library Dreams",
			"brand": "Bloom Sample Packs",
			"price": 39,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/oldlibrary_500x.jpg?v=1625874160",
			"gender": "Unisex"
		},
		"match": {
			"title": "Match",
			"brand": "Der Duft",
			"price": 110,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/Foto_DER_DUFT_MATCH_500x.jpg?v=1630486299",
			"gender": "Unisex"
		},
		"kar-wai": {
			"title": "Kar-Wai",
			"brand": "Carine Roitfeld",
			"price": 190,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/9eba791468f6eb4f332b4cf6c8a2b1c0d4011a9a_kar-wai-no-background-reduced_500x.jpg?v=1632307163",
			"gender": "Unisex"
		},
		"the-ghost-in-the-shell": {
			"title": "The Ghost In The Shell",
			"brand": "Etat Libre d'Orange",
			"price": 155,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/Ghost-in-the-Shell-flacon-100-ml_1800x1800_6a38eab9-76bd-4fc7-a90d-b9d697d75280_500x.jpg?v=1632307386",
			"gender": "Female"
		},
		"spice-bazaar-pack": {
			"title": "Spice Bazaar Pack",
			"brand": "Bloom Sample Packs",
			"price": 39,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/Spicebazaareditphoto_0351e99d-87a3-4df9-8dbf-e3ccc6c2f607_500x.jpg?v=1644416725",
			"gender": "Unisex"
		},
		"intime-extime": {
			"title": "Intime-Extime",
			"brand": "Pierre Guillaume White Collection",
			"price": 140,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/PIERRE-GUILLAUME-PARIS-PARFUM-COLLECTION-BLANCHE-INTIME-EXTIME-100ML_500x.png?v=1652202927",
			"gender": "Unisex"
		},
		"pg31-tonka-bodycon": {
			"title": "PG31 Tonka Bodykon",
			"brand": "Pierre Guillaume - Parfumerie Générale",
			"price": 140,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/products/tonkabodykon_500x.jpg?v=1668777890",
			"gender": "Unisex"
		},
		"sacreste": {
			"title": "Sacreste",
			"brand": "Laboratorio Olfattivo",
			"price": 120,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/sacreste_30537c77-f38c-4df0-8eda-aa4948cefa75_500x.jpg?v=1708450496",
			"gender": "Unisex"
		},
		"st-pauls-1": {
			"title": "St. Paul's",
			"brand": "Exaltatum",
			"price": 130,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/pauls_500x.jpg?v=1780922153",
			"gender": "Unisex"
		},
		"sous-le-pont-mirabeau": {
			"title": "Sous Le Pont Mirabeau",
			"brand": "Etat Libre d'Orange",
			"price": 155,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/SouslepontMirabeau100ml_5ac7f65b-8205-4d1f-81e1-70fd89082f81_500x.jpg?v=1684152518",
			"gender": "Unisex"
		},
		"arabesque": {
			"title": "Arabesque",
			"brand": "Ormonde Jayne",
			"price": 195,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/arabesque-88ml_1020x1530_5b8da67a-e434-4fe6-bd40-5aaba43b4088_500x.jpg?v=1696788803",
			"gender": "Unisex"
		},
		"smoky-soul": {
			"title": "Smoky Soul",
			"brand": "Olfactive Studio",
			"price": 200,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/OS_SMOKY_SOUL_100ML_WHITE_4472x_fbbe1f1f-2851-4b57-9689-8efa1fecb582_500x.jpg?v=1700064037",
			"gender": "Unisex"
		},
		"sugar-addict": {
			"title": "SUGAR ADDICT",
			"brand": "BORNTOSTANDOUT",
			"price": 182,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/SUGARADDICT_BOTTLE_500x.png?v=1710231628",
			"gender": "Unisex"
		},
		"a-grove-by-the-sea": {
			"title": "A Grove By The Sea",
			"brand": "Arquiste",
			"price": 195,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/ARQUISTE_A_GROVE_BY_THE_SEA_500x.jpg?v=1722411367",
			"gender": "Unisex"
		},
		"neroli-petitgrain": {
			"title": "Neroli & Petitgrain",
			"brand": "100BON",
			"price": 35,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/neroli_petit_grain_500x.jpg?v=1731682971",
			"gender": "Unisex"
		},
		"gold-balanced": {
			"title": "Gold | Balanced & Expressive",
			"brand": "Commodity",
			"price": 135,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/GOld_b68dbf50-e636-4905-9bec-9ec7ac9a6b43_500x.png?v=1740650427",
			"gender": "Unisex"
		},
		"book-personal": {
			"title": "Book | Personal",
			"brand": "Commodity",
			"price": 135,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/Book_b88ab5fe-1cd7-40c4-867e-c7da9f112031_500x.png?v=1740649756",
			"gender": "Unisex"
		},
		"yawahada": {
			"title": "Yawahada (Soft skin)",
			"brand": "J-Scent",
			"price": 122,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/yawahada-01_500x.jpg?v=1741339211",
			"gender": "Unisex"
		},
		"white-rice": {
			"title": "White Rice",
			"brand": "d'Annam",
			"price": 130,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/White-Rice_500x.jpg?v=1746626005",
			"gender": "Unisex"
		},
		"vietnamese-coffee": {
			"title": "Vietnamese Coffee",
			"brand": "d'Annam",
			"price": 130,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/Vietnamese-Coffee_500x.jpg?v=1746626102",
			"gender": "Unisex"
		},
		"tokyo-nights": {
			"title": "Tokyo Nights | ナイト",
			"brand": "d'Annam",
			"price": 130,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/Tokyo-Nights_500x.jpg?v=1746626539",
			"gender": "Unisex"
		},
		"pho-breakfast": {
			"title": "Pho Breakfast",
			"brand": "d'Annam",
			"price": 130,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/pho_breakfast_500x.jpg?v=1747315613",
			"gender": "Unisex"
		},
		"afrique-en-fleurs": {
			"title": "Afrique en Fleurs",
			"brand": "Reserve en Afrique 1934",
			"price": 150,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/1.Reserve_en_Afrique_Afrique_en_Fleurs_100ml_Bottle_500x.png?v=1754905382",
			"gender": "Unisex"
		},
		"marrakech-cologne": {
			"title": "Marrakech Cologne",
			"brand": "Mabra",
			"price": 60,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/mabra_marrakech_500x.jpg?v=1754916621",
			"gender": "Unisex"
		},
		"black-afgano": {
			"title": "Black Afgano",
			"brand": "Nasomatto",
			"price": 130,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/black_afgano_500x.jpg?v=1756323933",
			"gender": "Unisex"
		},
		"fantomas": {
			"title": "Fantomas",
			"brand": "Nasomatto",
			"price": 130,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/fanromas_500x.jpg?v=1756323244",
			"gender": "Unisex"
		},
		"dark": {
			"title": "Dark",
			"brand": "Akro",
			"price": 160,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/Akro_100-ML-Dark_500x.jpg?v=1756809885",
			"gender": "Unisex"
		},
		"megamare": {
			"title": "Megamare",
			"brand": "Orto Parisi",
			"price": 155,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/orto_megamare_500x.jpg?v=1758620777",
			"gender": "Unisex"
		},
		"terroni": {
			"title": "Terroni",
			"brand": "Orto Parisi",
			"price": 155,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/orto_terroni_500x.jpg?v=1758620655",
			"gender": "Unisex"
		},
		"portamarina": {
			"title": "Portamarina",
			"brand": "Agatho",
			"price": 305,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/portamania_500x.jpg?v=1764500453",
			"gender": "Unisex"
		},
		"celestial-object": {
			"title": "Celestial Object",
			"brand": "Liis",
			"price": 160,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/Liis_Silo_CelestialObject_500x.jpg?v=1764835866",
			"gender": "Unisex"
		},
		"floating": {
			"title": "Floating",
			"brand": "Liis",
			"price": 160,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/Liis_Silo_Floating_500x.jpg?v=1764836387",
			"gender": "Unisex"
		},
		"dawn-whispers": {
			"title": "Dawn Whispers",
			"brand": "L'Entropiste",
			"price": 185,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/dawn_500x.jpg?v=1766576329",
			"gender": "Unisex"
		},
		"wonderwood": {
			"title": "Wonderwood",
			"brand": "Comme Des Garcons",
			"price": 120,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/wonderwood_500x.jpg?v=1769329620",
			"gender": "Unisex"
		},
		"concrete": {
			"title": "Concrete",
			"brand": "Comme Des Garcons",
			"price": 160,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/concrete_500x.jpg?v=1769329773",
			"gender": "Unisex"
		},
		"copper": {
			"title": "Copper",
			"brand": "Comme Des Garcons",
			"price": 155,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/copper_500x.jpg?v=1769330410",
			"gender": "Unisex"
		},
		"white": {
			"title": "White",
			"brand": "Comme Des Garcons",
			"price": 100,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/white_500x.jpg?v=1769330222",
			"gender": "Unisex"
		},
		"black": {
			"title": "Black",
			"brand": "Comme Des Garcons",
			"price": 95,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/black_8652c882-6fb1-47d4-b691-a30985352886_500x.jpg?v=1769330871",
			"gender": "Unisex"
		},
		"cloud-essence-28-08": {
			"title": "Cloud Essence 28.08",
			"brand": "Neydo",
			"price": 80,
			"image": "https://cdn.shopify.com/s/files/1/2129/6897/files/neydo_cloud_1a934fe1-5740-42fa-8bcb-3b97d3db4657_500x.jpg?v=1770373674",
			"gender": "Unisex"
		}
	},
	"collections": {
		"architecture": {
			"title": "Architecture",
			"category": "Things & Design",
			"intro": "Architecture is the art of making air feel inhabited: stone, light, shadow, and threshold. This collection pairs buildings and movements with fragrances that seem to carry their own walls, weather, and echo.",
			"items": [
				{
					"item_title": "Notre-Dame de Paris",
					"item_subtitle": "Gothic cathedral, begun 1163",
					"handle": "st-pauls-1",
					"description": "A rain-dark nave, candles trembling beneath vaulted stone, and stained glass turning morning into jewel-toned dusk. It belongs with a scent that feels like incense rising through a vast interior, solemn but alive with light. Wearing it is like moving through a cathedral after the doors have closed, when every step seems to answer back. There is grandeur here, but also a human pulse under the arches."
				},
				{
					"item_title": "Bauhaus Dessau",
					"item_subtitle": "Walter Gropius, 1925",
					"handle": "paper-balanced",
					"description": "White walls, ribbon windows, and a staircase that seems to think in straight lines. The link is clarity: both the building and the scent strip away ornament until only structure and air remain. On the skin, it feels precise and bright, like a pencil line drawn across a clean page. You wear it as if you’ve just stepped out of a workshop at dawn."
				},
				{
					"item_title": "Unité d’Habitation",
					"item_subtitle": "Le Corbusier, Marseille, 1952",
					"handle": "concrete",
					"description": "A massive slab of housing lifted into sunlight, its balconies stacked like a city in profile. The scent matches that hard-edged confidence: brutal, graphic, and strangely intimate once you live inside it. Wearing it feels like carrying a city block on your shoulders without losing your composure. It is severe, but not cold."
				},
				{
					"item_title": "Imperial Hotel, Tokyo",
					"item_subtitle": "Frank Lloyd Wright, 1923",
					"handle": "pg16-jardins-de-kerylos",
					"description": "Low eaves, patterned stone, and reflected water making the whole place seem to hover. The fragrance echoes that balance of shelter and ornament, of geometry softened by heat and garden air. On the body, it feels composed and hospitable, like arriving somewhere designed to slow your breathing. There is elegance here, but also the calm of a room arranged with care."
				},
				{
					"item_title": "Fallingwater",
					"item_subtitle": "Frank Lloyd Wright, 1935",
					"handle": "a-grove-by-the-sea",
					"description": "A house leaning over the water, with rock, moss, and stream folded into the same frame. The scent feels equally rooted in the landscape, as if stone had learned to breathe beside a river. Wearing it is like standing barefoot on a cool terrace while the forest hums around you. It has the quiet authority of something that never needed to announce itself."
				},
				{
					"item_title": "Casa Batlló",
					"item_subtitle": "Antoni Gaudí, 1904–1906",
					"handle": "nuit-de-baklite",
					"description": "A façade of scales and bone, blue tiles flashing like fish skin in sun. The fragrance carries that same surreal vitality, all curve, shimmer, and a touch of danger under the beauty. On the wearer, it feels theatrical in the best way—like entering a ballroom through a dream. Nothing about it is straight, and that is the point."
				},
				{
					"item_title": "Sagrada Família",
					"item_subtitle": "Antoni Gaudí, begun 1882",
					"handle": "dark-side-of-the-goddess",
					"description": "Spires rising through haze, stone forested with carvings, light dropping in like a revelation. The scent mirrors that sacred density, where incense and flowers seem to meet in the same breath. Wearing it feels ceremonial, as though your ordinary day has been given a procession and a hymn. It is lush, devotional, and just a little uncanny."
				},
				{
					"item_title": "Heydar Aliyev Center",
					"item_subtitle": "Zaha Hadid, 2012",
					"handle": "floating",
					"description": "A white ribbon of a building lifting and folding as if it were caught mid-surge. The fragrance answers with the same sense of motion suspended in air, smooth and futuristic, never quite at rest. On the body, it feels sleek and buoyant, like silk in a moving car. You don’t wear it so much as glide through it."
				},
				{
					"item_title": "MAXXI",
					"item_subtitle": "Zaha Hadid, Rome, 2010",
					"handle": "mtal-hurlant",
					"description": "Concrete corridors twist and cross like a city map redrawn in motion. The scent has that same metallic, urban electricity, all hard surfaces and sudden reflections. Wearing it feels like walking through a gallery after dark, when the building itself becomes part of the exhibit. It is architectural swagger with a pulse."
				},
				{
					"item_title": "Church of the Light",
					"item_subtitle": "Tadao Ando, 1989",
					"handle": "lumire-blanche",
					"description": "A bare concrete room split by a single cross of daylight. The fragrance carries that exact tension between austerity and radiance, where emptiness becomes the source of feeling. On the skin, it feels hushed and luminous, like a private prayer in the middle of the afternoon. You wear it when you want stillness to look intentional."
				},
				{
					"item_title": "Koshino House",
					"item_subtitle": "Tadao Ando, 1984",
					"handle": "north",
					"description": "Concrete walls, cool shadow, and a winter sky pressed close to the glass. The scent feels pared back and crystalline, with the chill of clean air moving through a quiet room. Wearing it is like standing indoors with your coat still on, listening to the house breathe. It is restraint made beautiful."
				},
				{
					"item_title": "Brion Cemetery",
					"item_subtitle": "Carlo Scarpa, 1978",
					"handle": "iris-cendr",
					"description": "Water, stone, bronze, and moss arranged like a slow poem for the dead. The fragrance answers with powder and smoke, a tender, weathered elegance that feels touched by time. On the wearer, it becomes reflective and intimate, as if memory itself had a texture. It is melancholy, but exquisitely made."
				},
				{
					"item_title": "Querini Stampalia",
					"item_subtitle": "Carlo Scarpa, Venice, 1963",
					"handle": "venetian-red",
					"description": "Floodwater glinting against marble, thresholds cut with surgical grace, every detail listening to the canal. The scent feels similarly salt-kissed and mineral, with a Venetian brightness that never quite dries out. Wearing it is like carrying a pocket of the lagoon into a formal room. It has the poise of old stone and the restlessness of water."
				},
				{
					"item_title": "The Guggenheim Museum Bilbao",
					"item_subtitle": "Frank Gehry, 1997",
					"handle": "copper",
					"description": "Titanium panels catching the light like fish scales or a ship hull in motion. The fragrance shares that polished, futuristic gleam, a surface that changes mood every time you turn. On the body, it feels bold and reflective, as if you’ve stepped into a city skyline at sunset. It is architecture that wants to be seen from every angle."
				},
				{
					"item_title": "The Shard",
					"item_subtitle": "Renzo Piano, London, 2012",
					"handle": "701",
					"description": "Glass slicing upward into cloud, with wind and height written into every line. The scent feels brisk and vertical, with a clean, sparking edge that suggests cold air and distant views. Wearing it is like looking out from a high floor while the city blurs below. It has the clarity of altitude."
				}
			]
		},
		"art-movements": {
			"title": "Art Movements",
			"category": "Sound & Style",
			"intro": "Art movements are not only ideas on walls; they are weather systems, arguments, and private obsessions made visible. This collection pairs twelve turning points of modern art with fragrances that feel like rooms, streets, studios, and after-hours conversa",
			"items": [
				{
					"item_title": "Impressionism",
					"item_subtitle": "Late 19th century, France",
					"handle": "pluie-de-soleil",
					"description": "A riverbank at dawn, where the water keeps changing its mind and the light won’t sit still. Impressionism and this scent share that fleeting, luminous quality: nothing is fixed, everything is caught mid-breath. Wearing it feels like stepping outside before the city fully wakes, with damp air on your sleeves and gold in the trees. It is the feeling of looking twice because the first glance was already dissolving."
				},
				{
					"item_title": "Cubism",
					"item_subtitle": "Early 20th century, Paris",
					"handle": "concrete",
					"description": "A studio table seen from three angles at once, with a guitar, a glass, and a face broken into sharp, exact pieces. Cubism and this scent both refuse a single viewpoint; they build a new whole out of angles, fragments, and cool discipline. On the skin, it feels architectural and alert, like wearing a perfectly cut coat in a room full of mirrors. You feel composed, but never simple."
				},
				{
					"item_title": "Dada",
					"item_subtitle": "1916, Zurich and beyond",
					"handle": "rien",
					"description": "A cabaret table littered with torn paper, cigarette ash, and a joke that lands like a provocation. Dada and this scent share the thrill of sabotage: elegant, unruly, and impossible to take in one neat breath. Wearing it feels like arriving late on purpose, with a smile that says you know the rules and have chosen to ignore them. It is a beautiful interruption."
				},
				{
					"item_title": "Pop Art",
					"item_subtitle": "1950s-60s, Britain and the United States",
					"handle": "superlady",
					"description": "A supermarket shelf lit like a stage, where fruit glows brighter than the sun and everything looks newly famous. Pop Art and this scent both turn the everyday into spectacle, making sweetness feel bold, glossy, and impossible to overlook. Wearing it feels playful and self-aware, like stepping out in color when everyone else chose beige. It leaves the impression of a wink held a second too long."
				},
				{
					"item_title": "Minimalism",
					"item_subtitle": "1960s, United States",
					"handle": "paper-balanced",
					"description": "A white room, a single line, and the hush that arrives when nothing is trying to compete. Minimalism and this scent share that spare clarity, where restraint becomes its own kind of drama. Wearing it feels clean and exact, like a page waiting for the first mark or a gallery after closing time. You feel edited down to the essentials, and somehow more yourself."
				},
				{
					"item_title": "Japonisme",
					"item_subtitle": "Late 19th century, Europe",
					"handle": "sakura",
					"description": "A print laid flat beside an open window, with cherry blossom drifting in from the street below. Japonisme and this scent meet in that sense of delicacy, grace, and borrowed wonder, when Europe looked east and learned a new way to frame beauty. Wearing it feels light but deliberate, like folding a letter with care or tying a ribbon just so. There is calm in it, and a little astonishment too."
				},
				{
					"item_title": "Bauhaus",
					"item_subtitle": "1919-1933, Germany",
					"handle": "the-architects-club",
					"description": "A staircase of steel and glass in the early morning, all edges, shadows, and purpose. Bauhaus and this scent are drawn to structure: beauty stripped down to line, function, and the quiet confidence of good design. Wearing it feels precise and modern, like a tailored coat over a plain shirt, or a lamp that makes the whole room make sense. It has the energy of a workshop where the future is being assembled."
				},
				{
					"item_title": "Arte Povera",
					"item_subtitle": "Late 1960s, Italy",
					"handle": "terroni",
					"description": "A handful of earth on a stone floor, a rope, a branch, a trace of rain still clinging to the ground. Arte Povera and this scent both find power in the humble, the rough, the unpolished thing left in its natural state. Wearing it feels grounded and elemental, as if your clothes still remember the outdoors. There is dignity in its simplicity, and a stubborn kind of poetry."
				},
				{
					"item_title": "Land Art",
					"item_subtitle": "Late 1960s-70s, United States and beyond",
					"handle": "a-grove-by-the-sea",
					"description": "A spiral cut into salt-flat silence, or a line of stones disappearing into wind and distance. Land Art and this scent share a devotion to place, to weather, to the vastness that makes human gestures feel both small and monumental. Wearing it feels like carrying a shoreline with you, cool and mineral, touched by sun and salt. It is expansive, patient, and quietly unforgettable."
				},
				{
					"item_title": "Surrealism",
					"item_subtitle": "1920s onward, international",
					"handle": "fantomas",
					"description": "A melon rolling across a marble table at midnight, too bright to be ordinary and too strange to ignore. Surrealism and this scent both tilt reality just enough to make the familiar feel uncanny and dreamlike. Wearing it feels like moving through a lucid dream in polished shoes, where every object seems to have a secret life. It is playful, disorienting, and elegantly off-center."
				},
				{
					"item_title": "Expressionism",
					"item_subtitle": "Early 20th century, Germany and Austria",
					"handle": "rose-riot",
					"description": "A face lit from below in a theater of shadows, where emotion arrives before explanation. Expressionism and this scent share that urgent, inward heat: color pushed hard, feeling made visible, nothing held back. Wearing it feels intense and exposed, like speaking in a room where everyone has already noticed your pulse. It carries the charge of a confession delivered as a performance."
				},
				{
					"item_title": "Abstract Expressionism",
					"item_subtitle": "1940s-50s, New York",
					"handle": "ambroxan-pack",
					"description": "A huge canvas on the floor, paint flung and dragged, the room full of motion and accident. Abstract Expressionism and this scent both live in gesture rather than outline, in the drama of something taking shape without explaining itself. Wearing it feels expansive and kinetic, like a coat thrown on in a hurry before running into the night. It leaves you with the sense that feeling itself can be a form of architecture."
				}
			]
		},
		"brands": {
			"title": "Brands",
			"category": "Sound & Style",
			"intro": "Brands are the modern myths we can touch: a logo on a sleeve, a chair in a room, a phone in the hand, a box on the doorstep. This collection pairs twenty icons with scents that feel like their world — polished, restless, familiar, and strangely intimate.",
			"items": [
				{
					"item_title": "Apple",
					"item_subtitle": "1976, technology brand",
					"handle": "201",
					"description": "A white box opens on a desk, and the room seems to sharpen around it. Apple has always promised a clean future with a human pulse, and this bright, lucid scent feels like that first bite of an idea made visible. It suits the person who likes their world pared back, but never cold. There is always a little mischief in the shine."
				},
				{
					"item_title": "Hermès",
					"item_subtitle": "1837, fashion house",
					"handle": "902",
					"description": "A silk scarf is folded on a wooden table beside a leather saddle, the light falling like honey across both. Hermès carries the feeling of craft made almost ceremonial, and this warm, tobacco-ambered scent wears like a private room in a grand house. It gives the wearer a calm authority, as if every gesture has been rehearsed for years. Nothing here is hurried."
				},
				{
					"item_title": "Vitra",
					"item_subtitle": "1950, furniture and design company",
					"handle": "602",
					"description": "A chair sits alone in a sunlit gallery, all line and proportion, waiting to be noticed. Vitra turns furniture into an argument about modern life, and this dry, elegant scent has the same clear-boned confidence. On skin, it feels composed and intelligent, like living inside a well-edited room. The effect is quiet, but it stays with you."
				},
				{
					"item_title": "Patagonia",
					"item_subtitle": "1973, outdoor brand",
					"handle": "wind-from-mount-kailash",
					"description": "A jacket is damp with mountain mist, hanging from a tent line at dawn. Patagonia speaks in weather, distance, and the promise of getting back out there, and this herbal, cedar-laced scent feels like cold air moving through pine. It wears like someone who trusts the map, then ignores it when the trail becomes more interesting. Practical, yes — but with a soul full of horizon."
				},
				{
					"item_title": "Aesop",
					"item_subtitle": "1987, skincare and lifestyle brand",
					"handle": "myrrhiad",
					"description": "Amber bottles line a sink in a bathroom that feels more like a library than a washroom. Aesop has built its world from restraint, texture, and the pleasure of everyday rituals, and this tea-dark fragrance echoes that exact mood. On the wearer, it feels thoughtful and composed, as if even washing your hands is part of the aesthetic. Everything is considered, nothing is loud."
				},
				{
					"item_title": "Leica",
					"item_subtitle": "1914, camera brand",
					"handle": "pg08-intrigant-patchouli",
					"description": "A photographer waits at the edge of a street, one eye closed, the city held in a rectangle of glass. Leica is about precision, patience, and the thrill of catching the exact second the world reveals itself, and this sharp, shadowed scent has that same tension. It suits someone who notices reflections in windows and stories in passing faces. The feeling is focused, elegant, and slightly nocturnal."
				},
				{
					"item_title": "Le Creuset",
					"item_subtitle": "1925, cookware brand",
					"handle": "401",
					"description": "A Dutch oven sits on a stove, its enamel glowing like a painted object in a still life. Le Creuset makes the kitchen feel theatrical and generous, and this cinnamon-sandalwood warmth brings that same sense of a meal beginning before anyone has sat down. On the wearer, it feels welcoming and slightly nostalgic, like arriving just as the door opens and dinner is almost ready. It is domesticity with a bright, proud face."
				},
				{
					"item_title": "IKEA",
					"item_subtitle": "1943, furniture and homeware brand",
					"handle": "lumire-blanche",
					"description": "Flat-pack boards are spread across a floor, the room half-assembled and full of possibility. IKEA is the drama of making a home from pieces, and this almond-soft, airy scent carries that same approachable optimism. It feels easy to wear, like a clean T-shirt that somehow makes the whole day simpler. There is a little Scandinavian daylight in it."
				},
				{
					"item_title": "Nike",
					"item_subtitle": "1964, sportswear brand",
					"handle": "fat-electrician",
					"description": "A runner cuts through an empty street before sunrise, every footfall crisp against the pavement. Nike is motion turned into identity, and this lean vetiver scent feels like muscle memory and forward drive. On the wearer, it is clean, charged, and ready to move before anyone else has fully woken up. It has the energy of a finish line seen from far away."
				},
				{
					"item_title": "Tesla",
					"item_subtitle": "2003, electric vehicle brand",
					"handle": "mtal-hurlant",
					"description": "A car glides through a tunnel, all glass and silence, then flashes out into the night. Tesla is the spectacle of the future arriving early, and this metallic, gasoline-tinged scent catches that strange blend of machine and fantasy. It wears like someone who likes acceleration, glare, and being first to the next thing. The mood is sleek, restless, and a little dangerous."
				},
				{
					"item_title": "Patrón",
					"item_subtitle": "1989, tequila brand",
					"handle": "saint-julep",
					"description": "A crowded terrace glows at sunset, glasses sweating in the heat while music drifts from inside. Patrón belongs to long evenings that begin as celebration and end as memory, and this bright, boozy scent has that same golden looseness. On the wearer, it feels social and slightly glamorous, like arriving late but perfectly timed. Everything is a little warmer than usual."
				},
				{
					"item_title": "Moleskine",
					"item_subtitle": "1997, notebook brand",
					"handle": "old-library-dreams",
					"description": "A black notebook opens to a blank page, the paper holding the faint pressure of a pen waiting to begin. Moleskine has always suggested private thought made portable, and this ink-and-vanilla scent feels like a desk lamp in the evening. It suits the person who keeps lists, sketches, and half-finished chapters in their bag. Wearing it feels like carrying a secret room with you."
				},
				{
					"item_title": "Lululemon",
					"item_subtitle": "1998, athletic apparel brand",
					"handle": "you-or-someone-like-you",
					"description": "A studio mirror catches the light as someone rolls up a mat and steps back into the street. Lululemon lives in the space between discipline and ease, and this minty, green scent has that same fresh-breath confidence. It feels light on the body, like movement before the day gets complicated. The effect is polished, but never stiff."
				},
				{
					"item_title": "Muji",
					"item_subtitle": "1980, lifestyle and design brand",
					"handle": "002",
					"description": "A shelf of plain stationery, a glass, a folded shirt — everything reduced to what it needs to be. Muji is the poetry of less, and this clean neroli-musk scent has the same calm refusal of excess. On the wearer, it feels unforced, as if your life has been quietly decluttered while you were out. The beauty is in what it leaves out."
				},
				{
					"item_title": "Sony",
					"item_subtitle": "1946, electronics and entertainment brand",
					"handle": "cinematic",
					"description": "A screen flickers to life in a dark room, and the first note of the soundtrack lands like a curtain rising. Sony has long lived at the meeting point of sound, image, and desire, and this vivid, slightly electric scent feels like that instant before the opening scene. It wears with a sense of drama and technical finesse. The person wearing it seems tuned to the world in high definition."
				},
				{
					"item_title": "Rolex",
					"item_subtitle": "1905, watch brand",
					"handle": "500-years",
					"description": "A wrist lifts in a quiet room, and the watch catches the light with almost no effort at all. Rolex is about permanence, status, and the confidence of things built to outlast trends, and this rose-amber scent carries that same assured weight. It feels tailored and self-possessed on skin, like a decision already made. Nothing about it asks permission."
				},
				{
					"item_title": "Bose",
					"item_subtitle": "1964, audio brand",
					"handle": "cloud-9-juice",
					"description": "Headphones settle over the ears, and the city outside turns into a distant suggestion. Bose makes silence feel engineered, and this cool, watery fragrance has that same sense of private space arriving instantly. It wears like a soft barrier between you and the noise of the day. The feeling is calm, modern, and just a little luxurious."
				},
				{
					"item_title": "Dyson",
					"item_subtitle": "1991, engineering and home tech brand",
					"handle": "copper",
					"description": "A bladeless fan hums in a white room, moving air like a design object rather than an appliance. Dyson turns the ordinary into something almost futuristic, and this metallic, gingered scent mirrors that polished invention. On the wearer, it feels precise and a little sci-fi, as if even the air around you has been improved. It is cool, clever, and faintly theatrical."
				},
				{
					"item_title": "North Face",
					"item_subtitle": "1966, outdoor brand",
					"handle": "fathom-v",
					"description": "A hood is pulled up against wind on a cliff path above the sea. The North Face is built for exposure, weather, and the stubborn joy of going anyway, and this salt-bright scent feels like cold grass and open water. It wears with the honesty of someone who prefers real weather to a polished forecast. There is grit in it, but also freedom."
				},
				{
					"item_title": "Glossier",
					"item_subtitle": "2014, beauty brand",
					"handle": "the-ghost-in-the-shell",
					"description": "A bathroom mirror, a pink tube, a face in morning light — everything soft, close, and almost unfinished. Glossier made beauty feel intimate and conversational, and this milky, skin-close scent captures that same near-whisper mood. It feels like the version of yourself you meet before the day begins. Gentle, modern, and disarmingly personal."
				}
			]
		},
		"cars": {
			"title": "Cars",
			"category": "Things & Design",
			"intro": "Fifteen cars, fifteen ways to move through the century: some built for speed, some for work, some for charm, and some for the sheer pleasure of being impossible to forget. Each one is paired with a scent that feels like the same silhouette seen at dusk, h",
			"items": [
				{
					"item_title": "Citroën 2CV",
					"item_subtitle": "1948, France",
					"handle": "like-this",
					"description": "A little French car rattles down a country lane, its canvas roof catching a soft afternoon wind. It has the lovely stubbornness of something made to keep going through rain, errands, and ordinary miracles. Worn on the skin, this feels companionable and unshowy, like a scarf thrown over your shoulders before leaving the house. It carries the memory of gardens, mud, and the long road home."
				},
				{
					"item_title": "Mini Cooper",
					"item_subtitle": "1959, United Kingdom",
					"handle": "002",
					"description": "A red Mini darts through a narrow street, all corners and cleverness, as if it has never once wasted a movement. It shares the same quick grin as a city shortcut taken at the perfect moment. On the wearer, it feels bright, neat, and slightly mischievous, like a good idea arriving before anyone else has had one. It’s the scent of small size with a very loud personality."
				},
				{
					"item_title": "Volkswagen Beetle",
					"item_subtitle": "1938, Germany",
					"handle": "poudre-de-riz",
					"description": "A Beetle sits under streetlights after the rain, rounded and familiar, like a character actor everyone recognizes at once. It belongs to the world of postcards, student apartments, and long childhood drives with the windows cracked open. On skin, it feels soft-edged and nostalgic, as if memory itself had been polished by use. There is comfort here, but also a little oddness, which is exactly the charm."
				},
				{
					"item_title": "Fiat 500",
					"item_subtitle": "1957, Italy",
					"handle": "vanille",
					"description": "A tiny Fiat pauses beside a sunlit piazza, its paint bright against stone and shadow. It has the elegance of a sketch done in one line, all wit and proportion. Wearing it feels playful and intimate, like leaning out of a balcony to watch the afternoon unfold below. It leaves the impression of sweetness without fuss."
				},
				{
					"item_title": "Citroën DS",
					"item_subtitle": "1955, France",
					"handle": "lumire-blanche",
					"description": "A Citroën DS glides past in the evening like a spaceship that has chosen to live in Paris. Its shape still looks futuristic, even decades later, as if it arrived from a more graceful future than ours. On the wearer, it feels clean, luminous, and a little unreal, like white fabric catching light in a museum courtyard. It is the perfume equivalent of admiration held quietly in the throat."
				},
				{
					"item_title": "Jaguar E-Type",
					"item_subtitle": "1961, United Kingdom",
					"handle": "kar-wai",
					"description": "An E-Type waits in the half-light, long bonnet forward, ready to turn any road into a scene. It carries the glamour of a black-and-white film still: elegant, dangerous, and impossible to ignore. Worn close, it feels sleek and assured, with just enough shadow to keep things interesting. You don’t wear this to blend in; you wear it to be remembered at the wheel."
				},
				{
					"item_title": "Porsche 911",
					"item_subtitle": "1964, Germany",
					"handle": "match",
					"description": "A 911 is seen from behind on an empty road, compact and determined, like a sentence that ends exactly where it should. It has the discipline of engineering and the thrill of a sudden downshift. On the body, it feels precise and cool, but never sterile, like a tailored jacket worn with scuffed shoes. It’s for someone who likes motion to look effortless."
				},
				{
					"item_title": "Ferrari 250 GTO",
					"item_subtitle": "1962, Italy",
					"handle": "ombre-indigo",
					"description": "A Ferrari 250 GTO flashes past a grandstand, red paint catching the sun like a blade. It belongs to an era when racing looked almost aristocratic, all daring and polished metal. On the wearer, it feels expensive in the old sense: not loud, but unmistakably rare. The mood is velvet-lined speed, with a little smoke at the edges."
				},
				{
					"item_title": "Aston Martin DB5",
					"item_subtitle": "1963, United Kingdom",
					"handle": "monsieur",
					"description": "An Aston Martin DB5 sits outside a hotel at night, chrome and shadow sharing the frame. It carries the calm confidence of someone who never needs to raise their voice in a room. Worn on skin, it feels composed, dry, and impeccably dressed, like a hand on a steering wheel in leather gloves. There is old-world charm here, but also a steel spine underneath."
				},
				{
					"item_title": "Mercedes-Benz 300 SL Gullwing",
					"item_subtitle": "1954, Germany",
					"handle": "the-architects-club",
					"description": "The gullwing doors lift open like wings in a hangar, and suddenly the car feels less like transport than arrival. It has the drama of engineering turned into theatre. On the wearer, it feels architectural and polished, with the quiet thrill of being slightly too elegant for the street. It is for late dinners, sharp angles, and entrances that seem accidental only to everyone else."
				},
				{
					"item_title": "Chevrolet Corvette Sting Ray",
					"item_subtitle": "1963, United States",
					"handle": "mtal-hurlant",
					"description": "A Corvette Sting Ray idles under neon, all curves, chrome, and American confidence. It carries the heat of summer asphalt and the promise of a road that doesn’t end until the horizon does. Worn on the body, it feels flashy in the best way, with a little gasoline glamour and a jacket thrown over bare skin. It is pure motion, with a wink."
				},
				{
					"item_title": "Ford Mustang",
					"item_subtitle": "1965, United States",
					"handle": "rake-and-ruin",
					"description": "A Mustang leaves a strip of tire smoke at the edge of a parking lot, the kind of image that lives forever in American cinema. It’s brash, youthful, and built to announce itself before it even arrives. On the wearer, it feels hot-blooded and unruly, like a song turned up too loud with the windows down. This is the scent of open roads and bad decisions made beautifully."
				},
				{
					"item_title": "Alfa Romeo Spider",
					"item_subtitle": "1966, Italy",
					"handle": "rouge-avignon",
					"description": "An Alfa Romeo Spider waits beside a marina, paint glinting as if it has just come from a film set. It has the easy elegance of a summer afternoon that refuses to end. Worn close, it feels romantic and lightly windblown, like silk caught in a car door and then released. It’s the kind of scent that makes even a quick errand feel like a scene."
				},
				{
					"item_title": "Toyota 2000GT",
					"item_subtitle": "1967, Japan",
					"handle": "yawahada",
					"description": "A Toyota 2000GT sits low and exact, its lines so clean they feel almost drawn with a ruler. It has the poise of Japanese minimalism meeting the dream of a sports car. On the wearer, it feels smooth, quiet, and refined, with nothing extra and nothing missing. The effect is understated until you notice how long it stays in the mind."
				},
				{
					"item_title": "Citroën Méhari",
					"item_subtitle": "1968, France",
					"handle": "swim-sx",
					"description": "A Méhari bounces across a beach road with its plastic body and open-air ease, more attitude than machinery. It belongs to salt, sun cream, and the kind of holiday that never quite becomes polished. Worn on the skin, it feels breezy and sunlit, like bare feet on warm boards. It’s playful utility, dressed for the coast."
				}
			]
		},
		"cinema": {
			"title": "Cinema",
			"category": "People & Culture",
			"intro": "Every film is a scent, if you know how to catch it. These twenty titles drift from rain-dark streets to sun-struck coasts, from whispered interiors to rooms full of smoke, each one matched to a fragrance that feels like a frame frozen in the air.",
			"items": [
				{
					"item_title": "The Third Man",
					"item_subtitle": "1949, Carol Reed",
					"handle": "coeur-de-noir-1",
					"description": "A Ferris wheel turns above a broken city, while footsteps echo through wet stone and alleyway shadows. The film’s sly corruption and midnight wit meet a scent that feels like ink on paper, leather gloves, and a glass left half-finished in a bar after closing. Wear it and you become the one who knows too much, moving through the dark with a smile that never quite settles. It lingers like a secret passed under a door."
				},
				{
					"item_title": "Tokyo Story",
					"item_subtitle": "1953, Yasujirō Ozu",
					"handle": "white-rice",
					"description": "Shoes lined up at the entryway, tea cooling on a low table, a summer room made still by grief. The fragrance answers with the hush of rice paper and the tenderness of ordinary life, where love is often expressed in pauses rather than speeches. On the skin it feels clean, intimate, and almost unbearably human. You wear it like a memory handled carefully with both hands."
				},
				{
					"item_title": "Vertigo",
					"item_subtitle": "1958, Alfred Hitchcock",
					"handle": "iris-poudre",
					"description": "A woman in gray steps out of the fog as San Francisco tilts beneath the camera. That spiral of obsession, elegance, and impossible repetition finds its echo in a powdery veil that feels antique, haunted, and exquisitely controlled. Wearing it is like following someone up a staircase you already know will undo you. It leaves you with the sense that desire can be a beautiful trap."
				},
				{
					"item_title": "Breathless",
					"item_subtitle": "1960, Jean-Luc Godard",
					"handle": "pg14-2-costume-liquide",
					"description": "A cigarette burns down in a Paris room while the city flashes past in fragments of style and nerve. The film’s cool improvisation and stolen glances fit a scent that feels tailored, offhand, and slightly dangerous, like a jacket thrown on in a hurry. On the body it becomes a quicksilver mood: restless, glamorous, impossible to pin down. It wears like a line spoken over the shoulder while already walking away."
				},
				{
					"item_title": "8½",
					"item_subtitle": "1963, Federico Fellini",
					"handle": "lumire-blanche",
					"description": "A director stands in a dream of scaffolding, mirrors, and white light, unable to tell invention from confession. The fragrance meets that suspended state with almond softness and an airy brightness that feels both theatrical and private. Wearing it is like stepping into your own reverie and finding it furnished with silk curtains and unfinished thoughts. It is a scent for beautiful confusion."
				},
				{
					"item_title": "Persona",
					"item_subtitle": "1966, Ingmar Bergman",
					"handle": "the-ghost-in-the-shell",
					"description": "Two women share a room by the sea, and the silence between them becomes more revealing than speech. This scent mirrors that eerie closeness with a milky, skin-level softness that feels intimate and uncanny at once. On the wearer it is almost like borrowing another identity for the afternoon, then noticing your own reflection has shifted. It stays close, like a breath held too long."
				},
				{
					"item_title": "In the Mood for Love",
					"item_subtitle": "2000, Wong Kar-wai",
					"handle": "rouge-avignon",
					"description": "A corridor glows amber at dusk while rain taps at the windows and love passes by in impossible slow motion. The film’s velvet ache and disciplined longing find their match in rose warmed by sandalwood, as if a bouquet had been left in a hotel room after midnight. Wearing it feels restrained and devastating, like a hand that almost reaches out and then decides not to. It is romance seen through a curtain of smoke and memory."
				},
				{
					"item_title": "The Conformist",
					"item_subtitle": "1970, Bernardo Bertolucci",
					"handle": "venice-rococo",
					"description": "Snow-white interiors, polished shoes, and fascist elegance create a world where beauty has been recruited for menace. This fragrance answers with powder, rose, and a faint old-world glamour that feels immaculate on the surface and morally unstable underneath. On the body it becomes severe, composed, and faintly decadent, like a perfectly cut coat worn to a terrible appointment. It is the scent of looking immaculate while the room quietly closes in."
				},
				{
					"item_title": "Jeanne Dielman, 23 quai du Commerce, 1080 Bruxelles",
					"item_subtitle": "1975, Chantal Akerman",
					"handle": "poudre-de-riz",
					"description": "A kitchen table, a sink, a ritual repeated so precisely it begins to feel like a form of pressure. The fragrance echoes that patient domestic choreography with rose and powder, the air of a room where time has been carefully folded and refolded. Wearing it feels controlled, watchful, and deeply interior, as if every gesture carries hidden weight. It is quiet, but never empty."
				},
				{
					"item_title": "Mirror",
					"item_subtitle": "1975, Andrei Tarkovsky",
					"handle": "fallen-leaves",
					"description": "Grass bends under rain, a house stands half-remembered, and the past arrives like weather. This scent answers with woods, myrrh, and a soft autumnal hush, as if the landscape itself had been distilled from recollection. On the skin it feels contemplative and slightly mournful, like walking alone at the edge of a field just before sunset. It wears like a dream you cannot fully explain, only revisit."
				},
				{
					"item_title": "The Godfather Part II",
					"item_subtitle": "1974, Francis Ford Coppola",
					"handle": "bois-dascse",
					"description": "A dark room, a family table, and power moving quietly beneath the linen and candlelight. The film’s solemn grandeur and buried violence meet a scent of smoke, tobacco, and whisky, like a suit that has spent too long near a winter fire. Wearing it gives the sense of authority earned the hard way, with no need to raise the voice. It feels old, expensive, and dangerous in the calmest possible way."
				},
				{
					"item_title": "Taxi Driver",
					"item_subtitle": "1976, Martin Scorsese",
					"handle": "rien",
					"description": "Neon bleeds across a windshield while the city slides by in feverish reflections. The film’s grime, loneliness, and unstable bravado find a match in a scent that feels metallic, leathery, and a little feral, like a night that has gone on too long. On the wearer it becomes an armor of bad decisions and hard edges. It is the smell of a man who has mistaken isolation for destiny."
				},
				{
					"item_title": "Paris, Texas",
					"item_subtitle": "1984, Wim Wenders",
					"handle": "megamare",
					"description": "A red cap moves through a desert of light, and the horizon seems to swallow every unfinished sentence. This fragrance carries that vastness with salt, cedar, and a dry, sun-struck openness that feels both lonely and cleansing. Wearing it is like standing at the edge of something you cannot name, with wind in your shirt and the past somewhere far behind you. It is spacious, patient, and quietly heartbreaking."
				},
				{
					"item_title": "Blue Velvet",
					"item_subtitle": "1986, David Lynch",
					"handle": "nuit-de-baklite",
					"description": "A perfect suburban lawn gives way to a hidden room of velvet curtains and damaged desire. The scent mirrors that strange collision with leather, tuberose, and green darkness, as if innocence had been lit from below. On the skin it feels seductive and off-kilter, polished on the outside and wired with unease underneath. It is the perfume equivalent of smiling in a place you should probably leave."
				},
				{
					"item_title": "The Piano",
					"item_subtitle": "1993, Jane Campion",
					"handle": "teint-de-neige",
					"description": "A black piano sits on the shore while waves and silence press in around it. The fragrance answers with powder, rose, and the feeling of fabric dampened by sea air, delicate yet stubbornly alive. Wearing it feels private and intense, like carrying a whole inner weather system beneath a composed face. It is tender without being fragile."
				},
				{
					"item_title": "The Double Life of Véronique",
					"item_subtitle": "1991, Krzysztof Kieślowski",
					"handle": "shiny-amber",
					"description": "A woman watches her own reflection move as if it belonged to someone else. The film’s luminous uncertainty meets a scent that feels golden, translucent, and touched by something almost supernatural. On the wearer it becomes a second self: warmer than expected, mysterious in motion, impossible to fully hold. It glows like a thought you almost remember."
				},
				{
					"item_title": "Tampopo",
					"item_subtitle": "1985, Jûzô Itami",
					"handle": "vietnamese-coffee",
					"description": "Steam rises from bowls, noodles are lifted with ceremony, and appetite becomes its own kind of art. The fragrance meets that playful devotion with coffee, chocolate, and tonka, a rich, street-level pleasure that feels both comic and deeply serious. Wearing it is like entering a small restaurant at night and being immediately welcomed by warmth. It has the charm of something delicious shared without pretension."
				},
				{
					"item_title": "Oldboy",
					"item_subtitle": "2003, Park Chan-wook",
					"handle": "black-afgano",
					"description": "A man wakes in a room with no window, and the city beyond him becomes a maze of vengeance and hallucination. This scent carries that same heavy, hypnotic charge with coffee, incense, tobacco, and something shadowed at the edges. Wearing it feels intense and uncompromising, like a black coat after midnight and a plan you cannot take back. It is not comfort; it is obsession made visible."
				},
				{
					"item_title": "Crouching Tiger, Hidden Dragon",
					"item_subtitle": "2000, Ang Lee",
					"handle": "nightingale",
					"description": "A sword glides over tiled roofs, and bamboo bends under moonlight as if the air itself were participating in the duel. The film’s grace, restraint, and hidden longing find a perfect companion in rose, sandalwood, and a veil of incense that feels ceremonial and alive. On the skin it moves with poise, never heavy, always just beyond reach. It wears like silk caught for a second on a branch."
				},
				{
					"item_title": "The Grand Budapest Hotel",
					"item_subtitle": "2014, Wes Anderson",
					"handle": "pink-me-up",
					"description": "A pastel hotel lobby, a tray of pastries, and a concierge who seems to have stepped out of a perfectly arranged box of memories. The fragrance mirrors that jeweled symmetry with champagne brightness, berry sparkle, and rose, all of it trimmed in wit. Wearing it feels meticulously cheerful, like entering a lobby where every color has been chosen with a ruler. It is playful, elegant, and a little melancholy around the edges."
				}
			]
		},
		"cities": {
			"title": "Cities",
			"category": "Places & Time",
			"intro": "Cities are never just maps: they are weather, posture, appetite, and memory. This collection pairs twenty places with fragrances that feel like a street corner, a dusk-lit square, or the last train home.",
			"items": [
				{
					"item_title": "Paris",
					"item_subtitle": "France",
					"handle": "teint-de-neige",
					"description": "A pale apartment catches the afternoon light, and the city seems to drift through the curtains in a hush of silk and old mirrors. Paris and this scent share that same poised, intimate glamour — beauty worn close, never shouted. It feels like stepping out in a perfect coat and knowing the whole boulevard might turn to look. Then, just as quickly, the moment is gone, like a glove left on a café chair."
				},
				{
					"item_title": "New York",
					"item_subtitle": "United States",
					"handle": "flash-back-in-new-york",
					"description": "Steam rises from the grate while taxis slash through the rain and the avenues keep moving long after midnight. New York and this fragrance both feel electric, a little rough-edged, and impossible to ignore. It’s the scent of someone who knows how to disappear into a crowd and still leave a wake behind them. Wear it and you feel lit from within, like a window on a high floor."
				},
				{
					"item_title": "Tokyo",
					"item_subtitle": "Japan",
					"handle": "tokyo-nights",
					"description": "Neon blurs across wet pavement, and a late-night alley glows with cigarette smoke and plum-colored light. Tokyo and this scent meet in that exact hour when the city becomes cinematic and secretive. It feels sharp, polished, and strangely tender, like a silk jacket over a restless heart. You wear it as if you’ve just stepped out of a train station and into your own private film."
				},
				{
					"item_title": "London",
					"item_subtitle": "United Kingdom",
					"handle": "london-fog",
					"description": "Morning settles over brick façades, the street still damp, a paper cup warming your hands on the way to the Tube. London and this fragrance share a kind of tailored restraint, with a soft, fogged-in elegance underneath. It feels intelligent and composed, like a well-cut coat with a hidden lining. On the wearer, it reads as quiet confidence and a little wit."
				},
				{
					"item_title": "Istanbul",
					"item_subtitle": "Turkey",
					"handle": "arabesque",
					"description": "A ferry cuts across the water while the call to prayer floats above rooftops and the spice market hums in the distance. Istanbul and this scent are both full of crossings — East and West, shadow and gold, old stone and sudden heat. It feels richly adorned but never static, like moving through a palace that still has a pulse. Wear it and you carry the city’s layered, velvet-dark magnetism."
				},
				{
					"item_title": "Marrakech",
					"item_subtitle": "Morocco",
					"handle": "marrakech-cologne",
					"description": "At dusk, the square glows with lantern light, mint tea, orange peel, and the smoke of food stalls curling into the air. Marrakech and this fragrance share that immediate, bustling warmth — vivid, crowded, and alive with color. It feels like walking with bare wrists through a market at sunset, alert to every turn. On the skin, it is bright and shadowed at once, like carved wood in a courtyard."
				},
				{
					"item_title": "Reykjavik",
					"item_subtitle": "Iceland",
					"handle": "north",
					"description": "The sky hangs low over white rooftops, and the air feels so clean it almost rings. Reykjavik and this scent belong to the same northern silence, where snow and light seem to have their own language. It feels spare, modern, and startlingly calm, like standing by a harbor before the world wakes up. Wear it and you seem to arrive with the weather itself."
				},
				{
					"item_title": "Tbilisi",
					"item_subtitle": "Georgia",
					"handle": "bohemian",
					"description": "Balconies lean over narrow streets, laundry flutters above old stone, and the evening carries smoke from a hidden supper. Tbilisi and this fragrance share that bohemian, slightly unruly grace — romantic, weathered, and full of stories. It feels like velvet worn over a sharp mind, or a glass of something strong in a room full of music. On the wearer, it lands as warm, independent, and beautifully lived-in."
				},
				{
					"item_title": "Valletta",
					"item_subtitle": "Malta",
					"handle": "portamarina",
					"description": "Sun strikes limestone walls until the whole city seems carved from honey and salt. Valletta and this scent share that bright, naval stillness, where the sea is always nearby and history feels close enough to touch. It feels crisp but golden, like a white shirt drying in the wind above a harbor. Wear it and you carry a small, sunlit authority."
				},
				{
					"item_title": "Nagasaki",
					"item_subtitle": "Japan",
					"handle": "nightingale",
					"description": "Cherry blossoms drift across a hillside while the harbor glints below and temple bells soften the air. Nagasaki and this fragrance meet in that tender meeting of grief, beauty, and resilience. It feels ceremonial and luminous, like walking through a garden at the edge of the sea. On the wearer, it becomes a quiet, unforgettable grace."
				},
				{
					"item_title": "Buenos Aires",
					"item_subtitle": "Argentina",
					"handle": "saint-julep",
					"description": "A café window fogs up as music spills into the street and the night stretches late with promises. Buenos Aires and this scent share that dramatic, elegant pulse — a city that knows how to linger. It feels bright, boozy, and alive, like a hand placed at the waist before the first step of a dance. Wear it and you move as if every corridor were a stage."
				},
				{
					"item_title": "Lisbon",
					"item_subtitle": "Portugal",
					"handle": "sous-le-pont-mirabeau",
					"description": "Trams climb the hill while tiled façades catch the sun and the river flashes at the end of every street. Lisbon and this fragrance both feel a little wistful, a little salt-worn, and full of light that softens everything it touches. It feels like a postcard that has been folded and kept for years, still beautiful in the crease. On the wearer, it is easygoing but moving, like a song heard from an open window."
				},
				{
					"item_title": "Seoul",
					"item_subtitle": "South Korea",
					"handle": "you-or-someone-like-you",
					"description": "A rooftop café looks out over a city that stays awake long after the last subway leaves. Seoul and this scent share that cool, fast, mint-bright energy — polished, modern, and full of momentum. It feels clean without being plain, like a white shirt with a perfect cut. Wear it and you seem ready for anything, from a gallery opening to a midnight walk."
				},
				{
					"item_title": "Marrakesh",
					"item_subtitle": "Morocco",
					"handle": "rose-omeyyade",
					"description": "In a courtyard shaded from the heat, rose petals lie against stone while the air holds a trace of spice and dust. Marrakesh and this fragrance are both lush and architectural, built from color, shadow, and heat. It feels sumptuous but grounded, like jewelry worn with sandals and sun on the skin. On the wearer, it becomes a kind of regal ease."
				},
				{
					"item_title": "Venice",
					"item_subtitle": "Italy",
					"handle": "venice-rococo",
					"description": "Water laps at marble steps while chandeliers glow behind a curtain of dusk. Venice and this scent belong to a world of reflected light, powdered rooms, and beautiful decay. It feels theatrical and delicate, like a masked figure crossing a bridge at twilight. Wear it and you seem to belong to a painting that is still breathing."
				},
				{
					"item_title": "Hong Kong",
					"item_subtitle": "China",
					"handle": "kar-wai",
					"description": "Rain blurs the harbor lights and a narrow corridor glows with red signage and late-night possibility. Hong Kong and this fragrance share that cinematic tension — sleek surfaces, hidden longing, and a city always in motion. It feels intimate and sharp, like a glance held one second too long. On the wearer, it becomes a little mysterious, a little glamorous, and impossible to pin down."
				},
				{
					"item_title": "Milan",
					"item_subtitle": "Italy",
					"handle": "the-architects-club",
					"description": "A modern lobby, polished stone, and a perfect suit moving through the afternoon with no wasted gesture. Milan and this scent share that disciplined elegance, where design is a way of life. It feels tailored, intelligent, and quietly expensive without ever needing to prove it. Wear it and you seem to have an invitation somewhere better than everyone else’s."
				},
				{
					"item_title": "Casablanca",
					"item_subtitle": "Morocco",
					"handle": "encens-de-nuit",
					"description": "Evening settles over white walls, and the air fills with incense, herbs, and the last warmth of the day. Casablanca and this fragrance share a sense of threshold — between coast and desert, prayer and nightlife, old romance and modern speed. It feels shadowed and inviting, like a doorway left open after dark. On the wearer, it is composed, sensual, and a little cinematic."
				},
				{
					"item_title": "Sydney",
					"item_subtitle": "Australia",
					"handle": "sydney-rock-pool",
					"description": "Salt dries on skin after a swim, and the rocks keep the day’s heat long after the sun has gone. Sydney and this fragrance share that bright coastal ease with a clean, sunlit edge. It feels open, effortless, and a little golden, like hair still damp from the sea. Wear it and you carry the whole shoreline with you into the evening."
				},
				{
					"item_title": "Nairobi",
					"item_subtitle": "Kenya",
					"handle": "afrique-en-fleurs",
					"description": "Bougainvillea spills over a wall, the air is warm, and the city feels alive with color and movement. Nairobi and this scent share a floral richness that never turns fragile — it is proud, grounded, and full of life. It feels radiant and composed, like someone who knows the city’s pace and keeps up without breaking a sweat. On the wearer, it glows with warmth and self-possession."
				}
			]
		},
		"decades": {
			"title": "Decades",
			"category": "Places & Time",
			"intro": "Ten decades, each held like a still frame: the clink of glasses, the hiss of neon, the smell of rain on hot pavement. These pairings move from one century mood to the next, with each fragrance chosen as a small cinematic emblem.",
			"items": [
				{
					"item_title": "The Great Gatsby",
					"item_subtitle": "1925, F. Scott Fitzgerald",
					"handle": "202",
					"description": "A champagne tower trembles under a chandelier while a brass band leans into the room and everyone looks impossibly young. The scent matches that glittering rush of arrival, with a bright, sunlit sweetness that feels like silk sleeves and reckless hope. Wear it when you want to seem as if the night is still opening in front of you. It leaves the impression of a smile held just a little too long."
				},
				{
					"item_title": "Roman Holiday",
					"item_subtitle": "1953, William Wyler",
					"handle": "002",
					"description": "A scooter threads through Rome in the morning, past stone steps, café tables, and a city waking in pale gold. The fragrance carries that clean, buoyant sense of post-war freedom, as if the world has been scrubbed bright and given back to you. On the skin, it feels easy and polished, like a white shirt with the sleeves rolled once. It is optimism with good manners."
				},
				{
					"item_title": "Saturday Night Fever",
					"item_subtitle": "1977, John Badham",
					"handle": "pg31-tonka-bodycon",
					"description": "A mirrored dance floor flashes under colored lights while the room tilts between swagger and surrender. This pairing is all heat, rhythm, and the desire to be seen, with a softness underneath the shine. Wearing it feels like stepping into a crowd already moving to your beat. It has the glamour of a jacket thrown over bare shoulders at midnight."
				},
				{
					"item_title": "Do the Right Thing",
					"item_subtitle": "1989, Spike Lee",
					"handle": "602",
					"description": "A city block glows in hard summer light, brick walls holding the day’s heat long after the sun has moved on. The fragrance fits that charged, street-level energy: dry, tense, alive with edges. It feels like confidence sharpened by pressure, the kind that comes from knowing exactly where you stand. There is nothing decorative here, only presence."
				},
				{
					"item_title": "Reality Bites",
					"item_subtitle": "1994, Ben Stiller",
					"handle": "pg08-intrigant-patchouli",
					"description": "A video store, a half-finished coffee, a conversation that keeps circling the point without ever landing. This scent suits that era’s cool detachment, where irony was a shield and sincerity had to sneak in sideways. Wearing it feels a little like leaning against a wall and pretending not to care, while caring very much. It is smart, a touch bruised, and quietly magnetic."
				},
				{
					"item_title": "The Matrix",
					"item_subtitle": "1999, Lana and Lilly Wachowski",
					"handle": "701",
					"description": "Green code falls down a black screen while a leather coat turns in slow motion. The fragrance matches that electric, end-of-the-century pulse: sharp air, cold metal, and a whiff of something sacred hidden inside the machine. It feels sleek and alert on the body, as if you have just stepped out of one world and into another. Everything seems possible, and slightly dangerous."
				},
				{
					"item_title": "Lost in Translation",
					"item_subtitle": "2003, Sofia Coppola",
					"handle": "you-or-someone-like-you",
					"description": "A hotel room at dusk, the city glowing through the glass, a voice from the next room drifting in and out of reach. This pairing is about suspended time, about loneliness made elegant and strangely tender. Wearing it feels light, almost vaporous, like being carried by a breeze through a place you do not yet know. It is intimate without asking to be explained."
				},
				{
					"item_title": "Mad Men",
					"item_subtitle": "2007–2015, Matthew Weiner",
					"handle": "902",
					"description": "A low glass of amber liquor catches the light in an office after hours, the ashtray still warm beside it. The scent suits the decade’s return to polish and old rituals, but with a modern awareness of the cracks beneath the surface. On the wearer, it feels tailored and deliberate, like a sentence chosen for its pause as much as its meaning. There is smoke in the room, and ambition too."
				},
				{
					"item_title": "Her",
					"item_subtitle": "2013, Spike Jonze",
					"handle": "the-ghost-in-the-shell",
					"description": "A man walks alone through a city of soft screens and distant voices, while the future feels gentle instead of cold. The fragrance captures that strange tenderness of modern life, where technology and intimacy blur at the edges. Wearing it feels clean, luminous, and a little unreal, like skin remembered through glass. It is the scent of being human in a world that keeps changing shape."
				},
				{
					"item_title": "Everything Everywhere All at Once",
					"item_subtitle": "2022, Daniel Kwan and Daniel Scheinert",
					"handle": "204",
					"description": "A laundromat, a tax office, and a thousand possible lives colliding in one breathless afternoon. This scent fits the early 21st century’s overload and tenderness: strange, bright, and full of movement, yet anchored by something familiar and human. Wearing it feels playful and slightly unmoored, as if you are carrying several selves at once. In the end, it lands as a small, vivid act of care."
				}
			]
		},
		"literary-characters": {
			"title": "Literary Characters",
			"category": "People & Culture",
			"intro": "Characters are the great original costumes: they enter a room before they speak, and leave behind a weather of their own. This collection pairs twenty unforgettable figures from literature with scents that feel like the air around their most revealing sce",
			"items": [
				{
					"item_title": "Sherlock Holmes",
					"item_subtitle": "Arthur Conan Doyle, The Adventures of Sherlock Holmes",
					"handle": "pg08-intrigant-patchouli",
					"description": "A lamp burns low over a table strewn with ash, a violin case, and a page marked with impatient little notes. This scent suits the thrill of a mind always turning, always testing, always arriving before everyone else. It feels like wearing a sharp coat in a foggy street, brisk and exact, with a glint of mischief at the collar. You seem to know what everyone else has missed."
				},
				{
					"item_title": "Jay Gatsby",
					"item_subtitle": "F. Scott Fitzgerald, The Great Gatsby",
					"handle": "902",
					"description": "Green light trembles across black water while the house behind him glows with music and money. This scent carries the ache of wanting something beautiful so badly that it becomes a whole atmosphere. On the skin, it feels polished and cinematic, like stepping into a room that is already full of champagne and longing. There is glamour here, but also the hush after the orchestra has gone home."
				},
				{
					"item_title": "Lolita",
					"item_subtitle": "Vladimir Nabokov, Lolita",
					"handle": "poudre-de-riz",
					"description": "A summer dress spins through heat, a motel curtain stirs, and the afternoon feels too bright to trust. This scent echoes the novel’s dangerous innocence and the way beauty can be turned into a trap. Wearing it feels like a powder-soft image that never quite stays still, sweet at first glance but shadowed underneath. It lingers in the mind like a song heard through an open car window."
				},
				{
					"item_title": "Jean Valjean",
					"item_subtitle": "Victor Hugo, Les Misérables",
					"handle": "bois-dascse",
					"description": "A man walks hard through rain and lamplight, carrying another person’s future as if it were a lantern. This scent belongs to endurance, mercy, and the long road back to being human. On the skin it feels worn-in and noble, like a coat that has crossed too many winters and still keeps someone warm. There is smoke in it, but also the quiet of a door opening at last."
				},
				{
					"item_title": "Mrs Dalloway",
					"item_subtitle": "Virginia Woolf, Mrs Dalloway",
					"handle": "002",
					"description": "Flowers are being chosen in the morning while London moves like a tide through the streets. This scent mirrors the novel’s delicate drift between outward grace and inward weather. Wearing it feels poised and luminous, like a life arranged in a vase, then suddenly deepened by memory. It is social, reflective, and touched by the shimmer of passing time."
				},
				{
					"item_title": "Bartleby",
					"item_subtitle": "Herman Melville, Bartleby, the Scrivener",
					"handle": "old-library-dreams",
					"description": "A windowless office, a pile of papers, and a man who answers the world with a calm refusal. This scent captures the strange stillness of Bartleby’s silence and the melancholy of a life reduced to paper and routine. On the skin, it feels pale, hushed, and almost spectral, like a desk left standing after everyone has gone. It is the fragrance of a sentence that never quite ends."
				},
				{
					"item_title": "Don Quixote",
					"item_subtitle": "Miguel de Cervantes, Don Quixote",
					"handle": "wind-from-mount-kailash",
					"description": "A dusty road opens under a huge sky, and a knight rides toward a world only he can see. This scent matches the grandeur of delusion when it becomes a form of courage. Wearing it feels windy, spare, and a little wild, like setting out with a battered book in your saddlebag and a kingdom in your head. It has the romance of impossible quests."
				},
				{
					"item_title": "Anna Karenina",
					"item_subtitle": "Leo Tolstoy, Anna Karenina",
					"handle": "rouge-avignon",
					"description": "A train platform, a velvet gown, and a glance that seems to split a life in two. This scent follows the sweep of desire, scandal, and the terrible elegance of a woman who refuses to live half-alive. On the skin it feels rich and fevered, like candlelight reflected in polished wood and red fabric. It is beautiful in the way a storm is beautiful from indoors."
				},
				{
					"item_title": "Gregor Samsa",
					"item_subtitle": "Franz Kafka, The Metamorphosis",
					"handle": "nuit-de-baklite",
					"description": "Morning arrives, and the body is no longer obeying the old rules. This scent fits the uncanny moment when the familiar becomes strange, and the room itself feels like it is watching you. Wearing it feels tense and insect-bright, with a hard shell over something deeply vulnerable. It is the scent of waking into the wrong life."
				},
				{
					"item_title": "Frankenstein's Creature",
					"item_subtitle": "Mary Shelley, Frankenstein",
					"handle": "hermann-a-mes-cotes-me-paraissait-une-ombre",
					"description": "Snow lies over the mountains while a lonely figure moves through the world by moonlight and rejection. This scent belongs to the creature’s tragic tenderness and the cold distance that made him. On the skin it feels damp, electric, and wounded, like a heartbeat heard through winter air. There is sorrow in it, but also a terrible dignity."
				},
				{
					"item_title": "Emma Woodhouse",
					"item_subtitle": "Jane Austen, Emma",
					"handle": "106",
					"description": "A drawing room is full of conversation, ribbon, and the confident mistake of thinking you know everyone’s heart. This scent captures Emma’s wit, vanity, and eventual sweetness without losing her sparkle. Wearing it feels polished and charming, like a smile that arrives a second before the remark. It has the glow of a heroine who is still learning to see clearly."
				},
				{
					"item_title": "Heathcliff",
					"item_subtitle": "Emily Brontë, Wuthering Heights",
					"handle": "cuirs",
					"description": "Wind tears across the moors and the house seems to hold its breath against the dark. This scent suits Heathcliff’s ferocity, grief, and the way love in this novel can turn into weather. On the skin it feels rough, smoldering, and impossible to domesticate. It is the smell of a storm that has learned your name."
				},
				{
					"item_title": "Elizabeth Bennet",
					"item_subtitle": "Jane Austen, Pride and Prejudice",
					"handle": "rose-de-taif",
					"description": "She walks through a garden with a look that can turn wit into a weapon and laughter into grace. This scent reflects Elizabeth’s clarity, intelligence, and the quiet confidence beneath her teasing surface. Wearing it feels lively and self-possessed, like a conversation that keeps revealing a sharper edge. It is elegant without ever seeming eager to impress."
				},
				{
					"item_title": "Holden Caulfield",
					"item_subtitle": "J.D. Salinger, The Catcher in the Rye",
					"handle": "you-or-someone-like-you",
					"description": "A city block at dusk, a cigarette in the cold, and a voice that keeps trying to outrun disappointment. This scent catches Holden’s restless energy and the ache of wanting something honest in a world that feels fake. Wearing it feels brisk, cool, and a little defensive, like hands buried in pockets while you keep moving. It has the mood of a boy who notices everything and trusts almost nothing."
				},
				{
					"item_title": "Moby Dick",
					"item_subtitle": "Herman Melville, Moby-Dick",
					"handle": "megamare",
					"description": "A white shape breaks the surface and the sea suddenly feels ancient, vast, and hostile. This scent belongs to obsession on an epic scale, where the horizon itself becomes a challenge. On the skin it feels saline, immense, and untamed, like standing on a deck with salt in your mouth and fate on the line. It is less a fragrance than a force of nature."
				},
				{
					"item_title": "Siddhartha",
					"item_subtitle": "Hermann Hesse, Siddhartha",
					"handle": "qi",
					"description": "A river moves under morning light while a young man listens as if the water might answer him. This scent follows Siddhartha’s search for stillness, wisdom, and a life that cannot be inherited from books alone. Wearing it feels calm and spacious, like breath slowing beside a quiet shore. It has the clarity of a question finally becoming silence."
				},
				{
					"item_title": "Offred",
					"item_subtitle": "Margaret Atwood, The Handmaid's Tale",
					"handle": "the-ghost-in-the-shell",
					"description": "A red cloak crosses a gray street, and every detail feels watched, measured, and controlled. This scent mirrors the novel’s strange tension between bodily presence and enforced distance. On the skin it feels pale and intimate, like skin remembered rather than freely lived in. There is tenderness here, but also the chill of surveillance."
				},
				{
					"item_title": "Harry Potter",
					"item_subtitle": "J.K. Rowling, Harry Potter and the Philosopher's Stone",
					"handle": "sacreste",
					"description": "A candlelit hall, a staircase turning unexpectedly, and the smell of old stone and rain after a storm. This scent suits the first shock of entering a hidden world where wonder and danger arrive together. Wearing it feels like stepping into a cloak just a little too big, full of possibility and secret doors. It has the hush of magic before the spell is spoken."
				},
				{
					"item_title": "Jane Eyre",
					"item_subtitle": "Charlotte Brontë, Jane Eyre",
					"handle": "iris-cendr",
					"description": "A governess stands at a window while the wind tugs at the curtains and the house keeps its secrets. This scent reflects Jane’s stern independence, inward fire, and the quiet force of a woman who will not be diminished. Wearing it feels composed, intelligent, and slightly remote, like a steady gaze held across a darkened room. It is the fragrance of dignity under pressure."
				},
				{
					"item_title": "Othello",
					"item_subtitle": "William Shakespeare, Othello",
					"handle": "ombre-indigo",
					"description": "A candle flickers on dark wood while suspicion spreads faster than truth. This scent fits Othello’s tragic intensity, where love, power, and jealousy are braided too tightly to untie. On the skin it feels deep, nocturnal, and dramatic, like velvet moving through a corridor after midnight. It carries the weight of a heart pushed past reason."
				}
			]
		},
		"music-genres": {
			"title": "Music Genres",
			"category": "Sound & Style",
			"intro": "Fifteen genres, fifteen rooms of sound: candlelit courts, rehearsal basements, club fog, late-night static, and the bright hum of machines. Each pairing below treats music as a scene you can walk into and wear on your skin.",
			"items": [
				{
					"item_title": "Baroque",
					"item_subtitle": "A court of chandeliers and powdered sleeves",
					"handle": "teint-de-neige",
					"description": "A chandelier trembles above a hall of silk gloves, candles, and white powder dusted across a marble face. Baroque music and this scent share the same sense of ornament made intimate, grandness folded into a close human breath. Wearing it feels like stepping into a portrait that has just begun to move. Everything is polished, luminous, and faintly ceremonial."
				},
				{
					"item_title": "Prog Rock",
					"item_subtitle": "Long songs, shifting skies, and hidden doors",
					"handle": "wonderwood",
					"description": "A record spins while the room keeps changing shape: one doorway, then another, then a staircase that seems to lead nowhere and everywhere at once. Prog rock and this scent both feel engineered for wonder, for the pleasure of following a path that refuses to stay straight. On the body, it feels like curiosity with a spine — composed, strange, and always reaching farther than expected. There is drama here, but it is carefully built."
				},
				{
					"item_title": "Shoegaze",
					"item_subtitle": "Blurred lights on a rainy street at midnight",
					"handle": "chambre-noire",
					"description": "Neon smears across wet pavement while the singer keeps their eyes on the floor and the whole world turns gauzy at the edges. Shoegaze and this scent live in that blur, where feeling is more important than outline and distance becomes a kind of dream. Wearing it feels soft, private, and slightly untouchable, like being wrapped in a song no one else can quite hear. It is melancholy with a pulse."
				},
				{
					"item_title": "Ambient",
					"item_subtitle": "A room with no clock and an open window",
					"handle": "north",
					"description": "Snow light enters an empty room and settles on the windowsill without making a sound. Ambient music and this scent both create a horizon rather than a melody, a place where time loosens its grip. On the skin, it feels quiet and spacious, as if your thoughts have room to drift without landing. The effect is calm, but never blank."
				},
				{
					"item_title": "Dub",
					"item_subtitle": "Bass rolling through a half-lit basement",
					"handle": "bois-dascse",
					"description": "A speaker stack hums in the corner while smoke curls under the ceiling and the bass seems to arrive before the beat does. Dub and this scent share that low, cavernous motion, where echoes matter as much as the original sound. Wearing it feels like carrying a fire inside a dark room: warm, shadowed, and full of afterimage. It leaves the air feeling inhabited."
				},
				{
					"item_title": "Neo-Soul",
					"item_subtitle": "Velvet curtains, late supper, and an easy smile",
					"handle": "milk-balanced",
					"description": "A singer leans into the microphone as if speaking to one person across a candlelit table. Neo-soul and this scent both have that intimate glow, that feeling of warmth made elegant and human. On the wearer, it feels smooth and generous, like a favorite jacket thrown over evening clothes. It is comfort with style, tenderness with a little shine."
				},
				{
					"item_title": "Krautrock",
					"item_subtitle": "A motorway at dawn, all motion and machine light",
					"handle": "mtal-hurlant",
					"description": "Headlights cut through a grey horizon while engines idle like a restless heartbeat. Krautrock and this scent share a fascination with momentum, repetition, and the beauty of something industrial becoming hypnotic. Wearing it feels cool, metallic, and a little dangerous, as if you have slipped into a moving vehicle with no destination announced. It is modernity seen through smoke."
				},
				{
					"item_title": "Free Jazz",
					"item_subtitle": "A room where every instrument speaks at once",
					"handle": "rien",
					"description": "The band has already broken the script: horns flare, chairs scrape, and the music seems to be inventing itself in real time. Free jazz and this scent both refuse politeness, choosing intensity, friction, and sudden leaps over smoothness. On the body, it feels fearless and unscripted, like walking into a conversation that might become an argument or a revelation. Nothing is tidied away."
				},
				{
					"item_title": "Drill",
					"item_subtitle": "Streetlights, concrete, and a beat that won’t flinch",
					"handle": "rake-and-ruin",
					"description": "A hooded figure stands under a streetlamp while the city around them stays alert and unsentimental. Drill and this scent share that hard-edged, nocturnal energy: sharp, direct, and built from tension. Wearing it feels armored but not numb, like carrying your own weather through the block. It has the stare of a locked door and the heat behind it."
				},
				{
					"item_title": "Lo-Fi",
					"item_subtitle": "A bedroom desk, a lamp, and a cassette with tape hiss",
					"handle": "old-library-dreams",
					"description": "A notebook lies open beside a chipped mug, and the music arrives with the soft crackle of something well loved. Lo-fi and this scent both turn imperfection into atmosphere, making the intimate feel cinematic. On the wearer, it feels like a private afternoon that stretches into evening, thoughtful and a little nostalgic. It is the fragrance of staying in and making a world out of small things."
				},
				{
					"item_title": "Madrigal",
					"item_subtitle": "Voices in a vaulted chamber, close enough to touch",
					"handle": "quelques-fleurs-loriginal",
					"description": "A circle of singers stands beneath stone arches, their harmonies rising like incense in a chapel at dusk. Madrigal and this scent are both made for the human voice at its most delicate and exact, where beauty comes from restraint as much as flourish. Wearing it feels poised and a little old-world, as if you have entered a scene already halfway through its song. The air around you seems to listen back."
				},
				{
					"item_title": "Minimalism",
					"item_subtitle": "A glass room, a metronome, and a single line of light",
					"handle": "paper-balanced",
					"description": "A bare room holds one chair, one window, and the slow insistence of a repeated phrase. Minimalism and this scent share that pared-back clarity, where each detail matters because nothing is wasted. On the wearer, it feels clean, deliberate, and quietly architectural, like a white wall that still somehow holds emotion. Simplicity becomes its own tension."
				},
				{
					"item_title": "Psychedelic Rock",
					"item_subtitle": "Posters on the wall, colors melting into each other",
					"handle": "nightingale",
					"description": "A concert hall dissolves into flowers, smoke, and a sky that seems to pulse with color. Psychedelic rock and this scent both lean into trance and transformation, where the familiar slips into something lush and dreamlike. Wearing it feels vivid and slightly unreal, as if the day has acquired a secret door. It is sensual, surreal, and gloriously overfull."
				},
				{
					"item_title": "Ska",
					"item_subtitle": "A dance floor bouncing under bright brass",
					"handle": "saint-julep",
					"description": "The room is all motion: polished shoes, quick steps, brass flashing under the lights, laughter spilling across the floor. Ska and this scent share a buoyant kind of confidence, bright enough to lift the whole scene. Wearing it feels crisp, social, and a little mischievous, like arriving just as the party finds its rhythm. The mood is forward, playful, and impossible to stand still in."
				},
				{
					"item_title": "Electronic",
					"item_subtitle": "A club at 3 a.m., blue light on silver skin",
					"handle": "fat-electrician",
					"description": "A DJ bends over the deck while the room turns into pure pulse and light. Electronic music and this scent both feel like the future arriving in fragments: clean lines, strange glow, and a beat that seems to live inside the walls. On the wearer, it feels sleek and electric, as if your outline has been redrawn by neon. It is the sound of a city after midnight, translated into skin."
				}
			]
		},
		"painters": {
			"title": "Painters",
			"category": "People & Culture",
			"intro": "Painting is a way of making light stay still: a hand, a color, a room, a century. These pairings imagine what it might feel like to step out of a canvas and keep its weather on your skin.",
			"items": [
				{
					"item_title": "Mona Lisa",
					"item_subtitle": "c. 1503–1506, Leonardo da Vinci",
					"handle": "lumire-blanche",
					"description": "She sits in a dark room, wrapped in green velvet and distance, while the air around her seems to hold its breath. This scent echoes that quiet mystery with a pale, luminous softness, like candlelight caught on polished wood. Wearing it feels composed and intimate, as if you’ve just stepped away from a portrait and are still carrying its calm. There is nothing rushed here, only the slow confidence of a face that never fully gives itself away."
				},
				{
					"item_title": "The Birth of Venus",
					"item_subtitle": "c. 1485, Sandro Botticelli",
					"handle": "rose-omeyyade",
					"description": "A shell opens onto a shoreline of pale wind and sea foam, and the whole scene feels newly arrived in the world. This fragrance answers with a rosy glow and a warm, golden hush, like sunlight on skin after a long crossing. On the wearer, it feels lifted and ceremonial, as if every gesture has been softly crowned. It is beauty before language, and after it too."
				},
				{
					"item_title": "The Last Supper",
					"item_subtitle": "1495–1498, Leonardo da Vinci",
					"handle": "myrrhiad",
					"description": "A long table glows in the half-dark, with bread, hands, and conversation frozen at the edge of revelation. The tea-dark depth here meets that charged stillness, as if the room has just been touched by incense and memory. Wearing it feels thoughtful and slightly haunted, like standing in a silent refectory after everyone has gone. It carries the gravity of a story that still has one breath left in it."
				},
				{
					"item_title": "Self-Portrait with Thorn Necklace and Hummingbird",
					"item_subtitle": "1940, Frida Kahlo",
					"handle": "tobacco-tuberose",
					"description": "A face meets the viewer straight on, framed by thorns, leaves, and a small, stubborn bird. This scent holds that same fierce tenderness: floral, shadowed, and edged with something that refuses to be gentle. On the wearer, it feels like armor made of petals, a beauty that does not ask to be protected. It is intimate, defiant, and unforgettable at close range."
				},
				{
					"item_title": "Water Lilies",
					"item_subtitle": "c. 1916, Claude Monet",
					"handle": "aqueous-florals-sample-pack",
					"description": "The pond is all reflection and drifting color, with no clear border between sky, water, and flower. This scent mirrors that floating softness, as if the garden had dissolved into a mist of petals. Wearing it feels quiet and weightless, like standing at the edge of a lily pond just before dusk. It is less a statement than a moment of light passing over the surface."
				},
				{
					"item_title": "Starry Night",
					"item_subtitle": "1889, Vincent van Gogh",
					"handle": "nuit-de-baklite",
					"description": "The sky turns and swirls above a sleeping village, alive with blue fire and restless stars. This fragrance carries that charged nocturne energy, with green brightness and a strange, electric edge. On the wearer, it feels vivid and sleepless, like walking outside when the whole world is still awake in your head. It has the intensity of a night that will not sit quietly in memory."
				},
				{
					"item_title": "The Scream",
					"item_subtitle": "1893, Edvard Munch",
					"handle": "rien",
					"description": "A figure stands on a bridge while the sky seems to bend around a silent cry. This scent meets that raw, exposed feeling with smoke, leather, and a sharp, unsettling air. Wearing it feels like stepping into a storm with your nerves uncovered, dramatic but deeply human. It is the smell of emotion before it finds words."
				},
				{
					"item_title": "Guernica",
					"item_subtitle": "1937, Pablo Picasso",
					"handle": "bois-dascse",
					"description": "Broken bodies, black-white-grey, and a room shattered by history. This fragrance answers with smoke, wood, and the dry heat of something scorched and remembered. On the wearer, it feels severe and solemn, like carrying a witness statement in your coat. It does not decorate grief; it gives it shape."
				},
				{
					"item_title": "Composition VIII",
					"item_subtitle": "1923, Wassily Kandinsky",
					"handle": "concrete",
					"description": "Circles, lines, and angles collide like a score being played in color. This scent has the same abstract electricity, crisp and architectural, with a rhythm that feels built rather than painted. Wearing it feels alert and modern, as if you’ve stepped into a gallery where geometry has a pulse. It is movement turned into form."
				},
				{
					"item_title": "No. 5, 1948",
					"item_subtitle": "1948, Jackson Pollock",
					"handle": "mtal-hurlant",
					"description": "Paint is flung, dripped, and dragged across the canvas until the surface feels charged with motion. This fragrance has that same industrial rush, all metal, leather, and a flash of gasoline heat. On the wearer, it feels kinetic and unapologetic, like a studio floor after midnight. It’s a portrait of action rather than polish."
				},
				{
					"item_title": "One: Number 31, 1950",
					"item_subtitle": "1950, Mark Rothko",
					"handle": "ambre",
					"description": "Two vast blocks of color hover like doors that never quite open. This scent carries that quiet depth, warm and enveloping, with a solemn glow rather than a bright edge. Wearing it feels meditative, as if you’ve stepped into a chapel made of color and silence. It settles around you like a held note."
				},
				{
					"item_title": "Woman I",
					"item_subtitle": "1950–1952, Willem de Kooning",
					"handle": "pg81-lombre-fauve",
					"description": "A face emerges and disappears in thick, restless paint, at once tender and feral. This fragrance matches that tension with dark texture and a velvet shadow over skin. On the wearer, it feels untamed but elegant, like a portrait that keeps changing when you look away. It is beauty with teeth."
				},
				{
					"item_title": "The Great Wave off Kanagawa",
					"item_subtitle": "c. 1831, Hokusai",
					"handle": "megamare",
					"description": "A blue wall of water rises over boats and mountain, perfectly poised between grace and danger. This scent answers with salt, seaweed, and wind-battered wood, like standing on a shore before the weather turns. Wearing it feels vast and bracing, as if you’ve brought the ocean home with you. It is the thrill of the horizon just before it breaks."
				},
				{
					"item_title": "A Sunday on La Grande Jatte",
					"item_subtitle": "1884–1886, Georges Seurat",
					"handle": "002",
					"description": "People stand in dappled light on a riverbank, each figure held in a pointillist hush. This fragrance has the same clean, airy stillness, like linen in a park at noon. On the wearer, it feels composed and bright, a little distant in the most beautiful way. It’s the scent of a day arranged with exquisite patience."
				},
				{
					"item_title": "The Persistence of Memory",
					"item_subtitle": "1931, Salvador Dalí",
					"handle": "fantomas",
					"description": "Soft clocks droop over a landscape that feels both exact and impossible. This scent has that uncanny dream logic, cool and strange, with a metallic edge that keeps the scene from settling. Wearing it feels surreal but precise, like remembering a dream in perfect detail and no one believing you. It lingers like a thought that has melted at the edges."
				},
				{
					"item_title": "The Son of Man",
					"item_subtitle": "1964, René Magritte",
					"handle": "the-ghost-in-the-shell",
					"description": "A man in a suit stands before the sea, his face hidden by an apple that should not be there. This fragrance carries that same polished unreality, with a skin-close softness and a strange, luminous calm. On the wearer, it feels elegant and slightly absurd, like a secret tucked into a perfectly straight collar. It is mystery made ordinary, and that is the trick."
				},
				{
					"item_title": "Blue Poles",
					"item_subtitle": "1952, Jackson Pollock",
					"handle": "black",
					"description": "A field of black, white, and blue surges with poles, marks, and sudden impact. This scent has the same forceful contrast, smoky and inky, as if a studio had been left open to the night air. Wearing it feels bold and physical, with the energy of paint still drying on your hands. It is chaos held together by instinct."
				},
				{
					"item_title": "Untitled (Black on Gray)",
					"item_subtitle": "1969–1970, Mark Rothko",
					"handle": "dark",
					"description": "Two dark fields meet in a silence so deep it feels almost architectural. This fragrance echoes that austerity with cocoa-dark warmth and a shadowed hush. On the wearer, it feels private and severe, like a room with the curtains drawn at noon. It is minimal, but never empty."
				},
				{
					"item_title": "The Two Fridas",
					"item_subtitle": "1939, Frida Kahlo",
					"handle": "rose-riot",
					"description": "Two selves sit side by side, linked by a pulse of exposed feeling and stormy sky. This scent captures that split tenderness with rose, smoke, and a bright ember of color. Wearing it feels vulnerable and strong at once, as if your heart were visible but unbroken. It is a portrait of doubling, and of survival."
				}
			]
		},
		"photographers": {
			"title": "Photographers",
			"category": "People & Culture",
			"intro": "Fifteen photographers, fifteen ways of seeing: the alleyway, the flashbulb, the contact sheet, the long wait at a window. Each pairing below follows a visual instinct rather than a literal biography, as if a scent were another lens.",
			"items": [
				{
					"item_title": "Henri Cartier-Bresson",
					"item_subtitle": "Street photographer, decisive moment",
					"handle": "002",
					"description": "A cyclist cuts across a wet Paris street, a church bell still hanging in the air. This is the instant before the world notices itself, clean and exact, with a quiet pulse underneath. Wearing it feels like moving through the city with your collar turned up, alert to the next perfect alignment of light and gesture. Nothing is forced; everything lands at once."
				},
				{
					"item_title": "Vivian Maier",
					"item_subtitle": "Street photographer, hidden archive",
					"handle": "book-personal",
					"description": "A roll of undeveloped film sits in a drawer beside a wool coat and a string shopping bag. The feeling here is private and observant, as if a whole life were kept in careful silence until someone finally opened the box. On the skin, it feels like solitude with a notebook in hand, reserved but deeply alive. You seem to be walking just outside the frame, where the best stories often begin."
				},
				{
					"item_title": "Diane Arbus",
					"item_subtitle": "Portrait photographer, American outsider gaze",
					"handle": "rien",
					"description": "A motel curtain trembles before a camera flash, and the room is suddenly too bright to hide anything. The bond here is between fascination and unease, between tenderness and the hard edge of looking straight at what others avoid. Wearing it feels bold and unflinching, like meeting every room with your chin lifted. It has the strange dignity of a portrait that refuses to flatter."
				},
				{
					"item_title": "Saul Leiter",
					"item_subtitle": "Color street photographer, rainy windows and reflections",
					"handle": "venice-rococo",
					"description": "Steam blurs a café window while a red umbrella drifts past in the reflection. The connection is all softened edges and accidental beauty, the city seen as if through watercolor and glass. On the wearer, it feels elegant and slightly removed, like standing under an awning while the rain turns everything cinematic. You carry color the way some people carry memory: gently, and with precision."
				},
				{
					"item_title": "Daido Moriyama",
					"item_subtitle": "Japanese photographer, grain, speed, night streets",
					"handle": "black",
					"description": "A neon sign shudders over asphalt after midnight, and the street looks half-burned by light. This pairing shares a raw appetite for contrast, for blur, for the thrill of not fully knowing what you’ve caught. Wearing it feels restless and feral, as if you’ve stepped out of a darkroom and into the city still half-wild. It is photography with teeth."
				},
				{
					"item_title": "Wolfgang Tillmans",
					"item_subtitle": "Contemporary photographer, abstraction and everyday truth",
					"handle": "paper-balanced",
					"description": "A sheet of paper curls in daylight beside a table scattered with proofs, fruit, and a glass of water. The emotional thread is openness: the refusal to separate the monumental from the ordinary. On the body, it feels airy and intelligent, like a studio where experimentation is the real subject. You wear it as someone who trusts the accidental and the unfinished."
				},
				{
					"item_title": "Annie Leibovitz",
					"item_subtitle": "Portrait photographer, staged intimacy and celebrity theater",
					"handle": "gold-balanced",
					"description": "A dressing room glows under mirrors while a gown is being lifted into place just out of shot. The shared feeling is grand but human, a careful choreography that still leaves room for vulnerability. Wearing it feels polished and self-possessed, like arriving late to a premiere and somehow owning the whole hallway. It has the shine of a cover story with a pulse underneath."
				},
				{
					"item_title": "Helmut Newton",
					"item_subtitle": "Fashion photographer, sharp glamour and danger",
					"handle": "gold-bold",
					"description": "A hotel corridor stretches in lacquered shadows, all heels, mirrors, and a single open door. The bond is power staged as seduction, with a blade of humor cutting through the gloss. On the wearer, it feels severe and magnetic, like a glance held one second too long. You don’t enter a room so much as declare it yours."
				},
				{
					"item_title": "Richard Avedon",
					"item_subtitle": "Portrait and fashion photographer, stark clarity",
					"handle": "white",
					"description": "A white backdrop, a black coat, and a face caught in the merciless honesty of daylight. The connection is clarity itself: no scenery to hide behind, only posture, expression, and nerve. Wearing it feels crisp and composed, as if every gesture has been edited down to its essential line. It is elegance stripped to the bone."
				},
				{
					"item_title": "Sally Mann",
					"item_subtitle": "American photographer, memory, family, Southern heat",
					"handle": "iris-cendr",
					"description": "A porch in late summer holds the smell of dust, wood, and sun-warmed cloth. This scent and her work share a haunted tenderness, the sense that beauty and loss often sit in the same chair. Wearing it feels intimate and reflective, like holding an old photograph at the window. It lingers like a family story you can’t quite put down."
				},
				{
					"item_title": "Nan Goldin",
					"item_subtitle": "Photographer of intimacy, nightlife, and confession",
					"handle": "frustration",
					"description": "A kitchen at 3 a.m. is lit by a single bulb, with glasses, smoke, and laughter still hanging in the air. The emotional thread is closeness without polish, the raw honesty of people who have seen each other at their brightest and most bruised. On the skin, it feels vulnerable and alive, like telling the truth before you’ve decided to. It wears like a memory you never fully edited."
				},
				{
					"item_title": "Robert Mapplethorpe",
					"item_subtitle": "Photographer of form, flowers, and classical severity",
					"handle": "cuir-sacre",
					"description": "A white tulip stands in a black vase beside a marble plinth and a polished boot. The connection is discipline and desire, the way beauty can be both exact and dangerous. Wearing it feels immaculate and a little intimidating, as if your silhouette had been framed in gallery light. It is all line, contrast, and controlled heat."
				},
				{
					"item_title": "Cindy Sherman",
					"item_subtitle": "Conceptual photographer, self as character",
					"handle": "the-ghost-in-the-shell",
					"description": "A costume hangs on a chair while a face in the mirror is already becoming someone else. The shared thread is transformation: identity as performance, mask, and invention. Wearing it feels elusive and playful, like stepping into a role that keeps changing before the audience can settle. You become the image and the maker of it at once."
				},
				{
					"item_title": "Sebastião Salgado",
					"item_subtitle": "Documentary photographer, labor, earth, endurance",
					"handle": "terroni",
					"description": "A hillside of dark soil rises under a hard sky, and hands are busy at the edge of the frame. The emotional bond is gravity and reverence, a feeling for the human body as part of the land’s long story. On the wearer, it feels grounded and solemn, like boots on red earth after rain. It carries the weight of witness without losing its dignity."
				},
				{
					"item_title": "Rinko Kawauchi",
					"item_subtitle": "Japanese photographer, light, tenderness, everyday miracles",
					"handle": "celestial-object",
					"description": "Morning light lands on a bowl of rice, a curtain, and the edge of a sleeping hand. The connection is softness without sentimentality, the sense that small things can hold an entire universe. Wearing it feels calm and luminous, like noticing the world before it starts to speak loudly. It leaves you with the quiet astonishment of being alive in the ordinary."
				}
			]
		},
		"subcultures": {
			"title": "Subcultures",
			"category": "People & Culture",
			"intro": "Twelve scenes from the last century, each one a tribe, a uniform, a rhythm, a way of stepping into the street. These pairings follow the mood of the movement rather than the museum label: what it looked like, what it refused, and what it left hanging in t",
			"items": [
				{
					"item_title": "On the Road",
					"item_subtitle": "1957, Jack Kerouac",
					"handle": "myrrhiad",
					"description": "A diner at dawn, coffee cooling beside a notebook, the highway already waiting outside the window. Beatnik life was all smoke, loneliness, and sudden grace, and this scent moves with the same late-night seriousness. Wear it like a black turtleneck and a borrowed coat, as if you have just come from a basement reading and are not quite ready to go home. It feels contemplative, a little worn at the edges, and deeply alive."
				},
				{
					"item_title": "Quadrophenia",
					"item_subtitle": "1979, Franc Roddam",
					"handle": "002",
					"description": "A chrome scooter glints under a grey seaside sky, parked beside a row of sharp jackets and polished shoes. Mods lived for precision, speed, and the thrill of looking better than everyone else, and this fragrance carries that clean, bright confidence. On skin, it feels crisp and composed, like stepping into a club with your collar perfect and your soundtrack already in your head. There is a cool elegance to it, but never boredom."
				},
				{
					"item_title": "The Great Rock 'n' Roll Swindle",
					"item_subtitle": "1980, Julien Temple",
					"handle": "rake-and-ruin",
					"description": "A torn poster flaps on a brick wall while a crowd surges past in boots and safety pins. Punk was a refusal first and a style second: loud, jagged, funny, furious, and impossible to tidy up. This scent wears like a leather jacket that has survived too many nights and still looks better for it. It feels raw, confrontational, and gloriously unpolished."
				},
				{
					"item_title": "Trainspotting",
					"item_subtitle": "1996, Danny Boyle",
					"handle": "volcano",
					"description": "A warehouse floor shakes under strobe lights, the air thick with sweat, bass, and the promise of dawn. Rave culture turned the night into a shared hallucination, a place where strangers became a single moving body. This perfume feels like that moment just before sunrise, when everything is glowing and nothing is finished. Wear it when you want to feel electric, open, and slightly out of time."
				},
				{
					"item_title": "The Hunger",
					"item_subtitle": "1983, Tony Scott",
					"handle": "bois-dascse",
					"description": "A candle burns beside a black velvet curtain, and the room seems to breathe in slow, expensive shadows. Goth has always been romance with the lights turned low: beauty, decay, desire, and a taste for the dramatic. This scent wraps around you like a long coat in winter, heavy with ritual and midnight thought. It feels mysterious, elegant, and just a little dangerous."
				},
				{
					"item_title": "Endless Summer",
					"item_subtitle": "1966, Bruce Brown",
					"handle": "sydney-rock-pool",
					"description": "Salt dries on sunburned shoulders as boards lean against a fence and the ocean keeps its distance. Surfer culture is a devotion to weather, tide, and the brief golden hour when the day feels endless. This fragrance has the easy warmth of skin after a swim and the clean hush of waves retreating from the sand. Wearing it feels like carrying the coast with you, even inland."
				},
				{
					"item_title": "Kids",
					"item_subtitle": "1995, Larry Clark",
					"handle": "pg14-2-costume-liquide",
					"description": "A skate park at dusk, concrete scuffed white by wheels, with music leaking from a backpack speaker. Skaters move through the city like it was built to be misused: rails, ledges, curbs, and all the spaces in between. This scent feels lean and urban, with the cool defiance of someone who knows every shortcut. It wears close and fast, like a trick landed cleanly before anyone can applaud."
				},
				{
					"item_title": "The Decline of Western Civilization",
					"item_subtitle": "1981, Penelope Spheeris",
					"handle": "vi-et-armis",
					"description": "A rehearsal room lit by a single bulb, amps humming, the floor already sticky with spilled beer and noise. Punk's older, harsher cousin lives here too: the hardcore scene, all speed, sweat, and survival instinct. This fragrance has the texture of a basement show at full volume, where the air itself feels sharpened. It wears like a warning and a dare at once."
				},
				{
					"item_title": "The Craft",
					"item_subtitle": "1996, Andrew Fleming",
					"handle": "nuit-de-baklite",
					"description": "Four girls stand in a school corridor, their black clothes and pale faces turning the fluorescent hallway into a spell. Goth-adjacent teenage mystique has always been about making the ordinary world feel enchanted and a little cursed. This scent feels like velvet gloves, candle smoke, and the private thrill of being misunderstood on purpose. Wear it when you want your silence to say more than words ever could."
				},
				{
					"item_title": "Bend It Like Beckham",
					"item_subtitle": "2002, Gurinder Chadha",
					"handle": "remarkable-people",
					"description": "A football pitch at golden hour, trainers dusty, laughter carrying across the grass. This one belongs to the sporty, practical, rule-bending side of youth culture, where identity is built through motion and nerve. The scent feels bright and capable, with the clean confidence of someone who can run, argue, and win. It wears like momentum: quick, spirited, and impossible to ignore."
				},
				{
					"item_title": "The Last Days of Disco",
					"item_subtitle": "1998, Whit Stillman",
					"handle": "pink-me-up",
					"description": "A mirrored club catches the flash of sequins, champagne, and one last song before closing time. Disco’s afterlife is all glamour under strain: pleasure sharpened by exhaustion, and elegance that knows the night will end. This fragrance feels bubbly, rosy, and slightly tipsy, as if the room itself were blushing. Wear it when you want to arrive late and still feel like the main event."
				},
				{
					"item_title": "Riot Grrrl: 1991–1997",
					"item_subtitle": "Cultural movement, zines, basement shows",
					"handle": "rose-riot",
					"description": "A photocopied zine is passed hand to hand, its edges rough, its message impossible to soften. Riot grrrl turned anger into community, and DIY into a weapon with lipstick on it. This scent feels like a fist wrapped in roses: outspoken, intimate, and unafraid of contradiction. It wears with the heat of a voice that has finally decided to be heard."
				}
			]
		},
		"weather": {
			"title": "Weather",
			"category": "Places & Time",
			"intro": "Weather is never just weather: it is a stage, a pressure, a change in the air before anyone has said a word. This collection pairs ten atmospheric states with scents that feel like they belong to the same sky, the same street, the same hour.",
			"items": [
				{
					"item_title": "Frosty January Sun",
					"item_subtitle": "A bright, brittle winter morning",
					"handle": "north",
					"description": "A pale sun hangs over a street still edged in frost, turning windowpanes into small mirrors. The scent matches that clean, cold clarity, as if the day has been washed in silence and left to sparkle. Wearing it feels like stepping outside wrapped in air so crisp it almost rings. There is warmth here, but it arrives with discipline."
				},
				{
					"item_title": "August Thunderstorm Before Dawn",
					"item_subtitle": "The hour when the city holds its breath",
					"handle": "hermann-a-mes-cotes-me-paraissait-une-ombre",
					"description": "The sky is black-blue, and the first heavy drops strike pavement before the thunder has fully spoken. This pairing catches that charged stillness, when everything feels suspended between heat and release. On skin, it feels like walking fast through a sleeping street with the storm gathering behind you. You seem alert, private, and just a little dangerous."
				},
				{
					"item_title": "London Fog",
					"item_subtitle": "Grey light on the river and the bridges",
					"handle": "london-fog",
					"description": "A bus slides through a white-grey morning, and the city appears in fragments: a lamppost, a coat sleeve, the blur of the Thames. The scent echoes that soft enclosure, warm and muffled, like being indoors while the world dissolves outside the glass. Wearing it feels civilised and close to the body, as if you have your own weather system. It is the smell of wool, tea, and patience."
				},
				{
					"item_title": "Wet Snow at Dusk",
					"item_subtitle": "Slush, streetlights, and the last blue hour",
					"handle": "snowy-owl",
					"description": "Snow falls softly until it turns to wet shine on the pavement, and dusk makes every curb look silver. This fragrance carries that hush between winter and evening, when the city seems to exhale in slow motion. On you, it feels pale and dreamlike, but not fragile. It is the kind of cold that makes every sound feel farther away."
				},
				{
					"item_title": "Mediterranean Afternoon Haze",
					"item_subtitle": "Stone walls, salt air, and bright heat softened by distance",
					"handle": "pg16-jardins-de-kerylos",
					"description": "The afternoon blurs over white stone and fig trees, with the sea just visible as a bright strip beyond the heat. The scent mirrors that sunlit haze, where everything is softened at the edges but still glowing. Wearing it feels easy and luminous, like linen warmed by the day. You carry the impression of a holiday that has already become memory."
				},
				{
					"item_title": "Monsoon Downpour",
					"item_subtitle": "Rain hitting the ground all at once",
					"handle": "bat-2020",
					"description": "The first downpour arrives like a curtain, drumming on roofs, leaves, and metal awnings in one sudden rush. This scent belongs to that saturated moment when earth wakes up under water. On skin, it feels muddy, green, and alive, as if your clothes have picked up the scent of the storm itself. You move through it with the pleasure of being completely inside the weather."
				},
				{
					"item_title": "Dry Heatwave",
					"item_subtitle": "Streets shimmering at noon",
					"handle": "sunsuality",
					"description": "The pavement trembles in the glare, and even the shadows seem to have been baked thin. The fragrance answers with a bright, sunstruck feeling, citrus and skin and heat held in the air. Wearing it feels bare-armed and self-possessed, like a long afternoon with nowhere urgent to go. It is heat without drama, only insistence."
				},
				{
					"item_title": "Sea Mist at First Light",
					"item_subtitle": "A harbour before the boats begin",
					"handle": "entre-ciel-et-mer",
					"description": "The harbour is half-hidden, with ropes, gulls, and masts appearing and disappearing in the mist. This pairing catches that salt-washed in-between state, where sky and water seem to trade places. On you, it feels cool and spacious, like breathing in before the day begins. It leaves the impression of someone who has just come in from the edge of the world."
				},
				{
					"item_title": "Golden Autumn Wind",
					"item_subtitle": "Leaves turning in the park",
					"handle": "fallen-leaves",
					"description": "A gust lifts dry leaves into the air, and the park flashes with copper, gold, and brown. The scent echoes that moment of turning, when the season seems to crackle underfoot. Wearing it feels gentle but storied, like a coat that has already seen a few good walks. There is comfort in it, and a little melancholy too."
				},
				{
					"item_title": "First Snowfall",
					"item_subtitle": "The city altered overnight",
					"handle": "cloud-essence-28-08",
					"description": "By morning, the world is quieter, as if someone has laid a white cloth over the streets. This fragrance carries that clean, hushed surprise, the feeling of looking out and finding everything changed. On skin, it feels soft and weightless, almost like breath on a window. It is the scent of a day that begins in wonder."
				}
			]
		},
		"world-cuisines": {
			"title": "World Cuisines",
			"category": "Things & Design",
			"intro": "Fifteen cuisines, each treated like a scene: a table lit from one side, steam rising, hands moving, a city or memory just beyond the frame. These pairings are less about ingredients than about mood — the hush before a first bite, the clatter of a late sup",
			"items": [
				{
					"item_title": "Kaiseki",
					"item_subtitle": "Japanese multi-course dining tradition",
					"handle": "white-rice",
					"description": "A lacquer tray gleams beside a window where rain draws silver lines down the glass. Kaiseki is all precision and pause, a meal that feels composed like a haiku and then gone in a breath. On skin, this wears like quiet confidence — clean, intimate, and almost ceremonial. It feels like bowing your head before the first course arrives."
				},
				{
					"item_title": "Arancini at Dawn",
					"item_subtitle": "Sicilian street food culture",
					"handle": "arancia-di-sicilia",
					"description": "A paper cone of fried rice balls is passed across a sun-warmed counter while scooters buzz past the curb. Sicilian street food has the joy of a city that refuses to be eaten politely. This scent feels bright and immediate, like laughter carried through an open piazza. Wearing it is like stepping into the morning with your hands still dusted in flour and salt."
				},
				{
					"item_title": "Mezze Table",
					"item_subtitle": "Lebanese shared dining",
					"handle": "neroli-petitgrain",
					"description": "Small plates arrive in a slow parade: olives, herbs, bread torn by hand, a table that keeps expanding. Lebanese mezze is hospitality made visible, a meal that turns conversation into a main course. On skin, it feels airy and generous, like being welcomed before you’ve even taken your coat off. It leaves the impression of a long afternoon that never quite wants to end."
				},
				{
					"item_title": "Oaxaca Market Morning",
					"item_subtitle": "Oaxacan food culture",
					"handle": "marrakech-cologne",
					"description": "Smoke drifts above a market stall where chiles, citrus, and warm corn seem to catch the light all at once. Oaxacan cooking has the depth of old stone and the color of woven cloth hung in the sun. This fragrance feels earthy, vivid, and slightly ceremonial, like a hand pressed to a clay wall. Wearing it is like carrying a festival in your pocket without making a sound."
				},
				{
					"item_title": "Supra at Midnight",
					"item_subtitle": "Georgian feast culture",
					"handle": "bois-sikar",
					"description": "A long table glows under low lamps, glasses lifted, speeches rising and falling like music. The Georgian supra is abundance with a spine — a feast that can turn solemn, comic, and tender in the same hour. This scent feels smoky and resonant, like a room where the candles have burned low but no one has left. It wears like being the last person still awake, listening for one more toast."
				},
				{
					"item_title": "Korean BBQ Smoke",
					"item_subtitle": "Korean barbecue culture",
					"handle": "smoky-soul",
					"description": "A grill hisses in the center of the table while tongs flash and meat caramelizes at the edges. Korean BBQ is social electricity: fast hands, shared plates, and the thrill of food made in front of you. On skin, this feels warm, savory, and alive with motion. It’s the scent of leaving a restaurant with your clothes carrying the memory of the night."
				},
				{
					"item_title": "French Bistro Lunch",
					"item_subtitle": "Parisian neighborhood dining",
					"handle": "no-89",
					"description": "A striped awning shades a tiny terrace where glasses catch the light and the lunch crowd leans in over conversation. The French bistro is not about spectacle; it’s about rhythm, ease, and the pleasure of a table that knows you. This scent feels polished without stiffness, like a well-cut jacket worn all day. It carries the mood of a city lunch that somehow turns into evening."
				},
				{
					"item_title": "Pho Breakfast",
					"item_subtitle": "Vietnamese morning food culture",
					"handle": "pho-breakfast",
					"description": "Steam rises from a bowl before the street is fully awake, and the first spoonful wakes everything else with it. Pho at breakfast has the feeling of a city starting its engine — brisk, fragrant, and deeply comforting. This scent feels clear and bright, but with a savory edge that keeps it human. Wearing it is like beginning the day with a promise you intend to keep."
				},
				{
					"item_title": "Tapas at Golden Hour",
					"item_subtitle": "Spanish sharing plates",
					"handle": "saint-julep",
					"description": "Small plates and cold drinks gather under a terrace awning while the light turns amber on the pavement. Tapas culture is all about movement between people, from one bite to the next, one story to another. This fragrance feels cheerful and slightly mischievous, like a summer evening that keeps finding excuses to continue. It wears like the moment when the second round arrives and nobody checks the time."
				},
				{
					"item_title": "Dim Sum Cart",
					"item_subtitle": "Cantonese tea-house culture",
					"handle": "intime-extime",
					"description": "A cart rattles past with bamboo steamers stacked like little architectural drawings. Dim sum is a morning of small revelations, each bite arriving with the elegance of something briefly lifted open. This scent feels soft, milky, and hushed, like porcelain warmed by hands. Wearing it is like sitting by a window while the city slowly learns to wake up."
				},
				{
					"item_title": "Feijoada Sunday",
					"item_subtitle": "Brazilian home cooking",
					"handle": "sugar-addict",
					"description": "A heavy pot sits on the stove while the house fills with the kind of warmth that means people are on their way. Feijoada carries the feeling of Sunday: unhurried, generous, and made for lingering at the table. This scent feels rich and dark, with a sweetness that arrives like dessert after a long conversation. It wears like a room full of relatives, music, and sunlight on tile."
				},
				{
					"item_title": "Ceviche Counter",
					"item_subtitle": "Peruvian coastal food culture",
					"handle": "202",
					"description": "Ice-cold fish is sliced in a room that smells of sea air, citrus, and sharp knives. Ceviche has the snap of coastal daylight — clean, quick, and bright enough to make you sit up straighter. This fragrance feels like a splash of salt water on the wrist, crisp and immediate. Wearing it is like standing at the edge of a harbor with the sun reflecting off the plates."
				},
				{
					"item_title": "Tasting Menu in Tokyo",
					"item_subtitle": "Contemporary Japanese dining",
					"handle": "201",
					"description": "A dessert arrives on a plate so spare it feels like a thought, and then the next course changes the whole room. Modern Japanese dining often balances delicacy with a quiet, exacting wit. This scent feels polished and luminous, with a clean sweetness that never overstates itself. It wears like a silk shirt under a dark coat — discreet, but unforgettable when you catch it again."
				},
				{
					"item_title": "Marrakech Spice Stall",
					"item_subtitle": "Moroccan food culture",
					"handle": "spice-bazaar-pack",
					"description": "A stall opens onto a lane of dust and color, where pyramids of spice look almost too vivid to be real. Moroccan food culture feels like a market at dusk: fragrant, layered, and alive with bargaining voices. This scent feels warm and textured, like fingers brushing through a bowl of saffron and cumin. Wearing it is like carrying the city’s heat home on your sleeves."
				},
				{
					"item_title": "Paris Patisserie Window",
					"item_subtitle": "French dessert culture",
					"handle": "vanillaco-sweet-shades-in-perfume-pack",
					"description": "Behind the glass, rows of pastries sit under perfect light, each one glossy enough to pause traffic. French dessert culture is theatre in miniature — precise, alluring, and impossible to ignore. This scent feels indulgent without becoming cloying, like the first bite of something you meant to share. Wearing it is like leaving the bakery with powdered sugar on your coat and no intention of brushing it off."
				}
			]
		},
		"writers": {
			"title": "Writers",
			"category": "People & Culture",
			"intro": "Twenty writers, twenty rooms of air and paper: a library at dusk, a train window at dawn, a desk lit by one stubborn lamp. Each pairing below follows a different literary weather pattern — smoke, tea, salt, powder, ink, fruit, and the hush between sentenc",
			"items": [
				{
					"item_title": "Jorge Luis Borges",
					"item_subtitle": "1899–1986, Argentina",
					"handle": "old-library-dreams",
					"description": "A narrow room lined with shelves, the lamp pooling gold over old paper and a page half-turned. It shares Borges’s love of labyrinths: the feeling that every corridor leads to another corridor, and every sentence opens a hidden door. Wearing it feels like carrying a private archive, intimate and slightly unreal, as if memory itself had a fragrance. A quiet, cerebral shadow that still glows warm at the edges."
				},
				{
					"item_title": "Sei Shonagon",
					"item_subtitle": "c. 966–c. 1017, Japan",
					"handle": "teint-de-neige",
					"description": "A silk sleeve brushed against a screen, powder drifting in the stillness of a Heian room. It suits Sei Shonagon’s jewel-box attention to detail, to the small rituals that make a life feel exquisitely observed. On the skin it feels poised and luminous, like a glance held a second longer than necessary. Elegant, exact, and faintly mischievous."
				},
				{
					"item_title": "Ernest Hemingway",
					"item_subtitle": "1899–1961, United States",
					"handle": "bois-dascse",
					"description": "A stone terrace at night, a glass set down beside a cloud of smoke and a dark horizon. The scent has the same blunt gravity as Hemingway’s prose: spare, weathered, and impossible to mistake for softness. Wearing it feels like standing straight in a wind that has crossed oceans and wars. It leaves the impression of a man who has said more by saying less."
				},
				{
					"item_title": "W. G. Sebald",
					"item_subtitle": "1944–2001, Germany",
					"handle": "indigo-smoke",
					"description": "A railway carriage passing through rain, fields blurred into one long, grey memory. It mirrors Sebald’s drifting, haunted sentences, where history arrives as mist, ash, and a footstep on gravel. On the body it feels contemplative and distant, like walking with your hands in your coat pockets through someone else’s past. A fragrance for archives, ruins, and the ache of looking back."
				},
				{
					"item_title": "Haruki Murakami",
					"item_subtitle": "1949–, Japan",
					"handle": "book-balanced",
					"description": "A late-night kitchen, a bowl of noodles, jazz leaking from another room, and the city humming outside the window. It catches Murakami’s strange balance of the ordinary and the uncanny, where a missing cat can feel as important as a love affair. Wearing it feels solitary but not lonely, as if you’ve stepped through a side door in the world. Cool, intimate, and just a little surreal."
				},
				{
					"item_title": "Leo Tolstoy",
					"item_subtitle": "1828–1910, Russia",
					"handle": "fougere-royale",
					"description": "A winter estate under a white sky, horses steaming in the yard, boots leaving dark marks in the snow. It suits Tolstoy’s vast moral weather: the grandeur, the discipline, the human scale of a life examined closely. On the skin it feels broad-shouldered and formal, yet alive with movement, like a long walk across frozen ground. A scent with the authority of a portrait painted in full light."
				},
				{
					"item_title": "Fernando Pessoa",
					"item_subtitle": "1888–1935, Portugal",
					"handle": "lost-generation",
					"description": "A café table in Lisbon, a cup gone cold, notebooks stacked beside a window that looks out on bright stone streets. The fragrance carries Pessoa’s many selves: singular and divided, intimate and theatrical, always slightly in disguise. Wearing it feels like inhabiting a private city of inner rooms, each one with a different voice at the door. Quietly haunting, with a beautiful sense of distance."
				},
				{
					"item_title": "Annie Dillard",
					"item_subtitle": "1945–, United States",
					"handle": "wind-from-mount-kailash",
					"description": "A trail at first light, sage crushed underfoot, the air sharp with altitude and attention. It matches Dillard’s fierce wonder at the physical world, where a blade of grass can feel as large as revelation. On the body it feels awake, lucid, and a little untamed, like standing alone on a ridge and listening hard. A scent for observation that becomes devotion."
				},
				{
					"item_title": "Matsuo Bashō",
					"item_subtitle": "1644–1694, Japan",
					"handle": "north",
					"description": "Snow gathering on a branch, the world reduced to a hush of white and breath. It echoes Bashō’s haiku clarity: a landscape distilled to one perfect, passing moment. Wearing it feels like moving carefully through silence, alert to every small change in light. Spare, cold, and radiant with stillness."
				},
				{
					"item_title": "Virginia Woolf",
					"item_subtitle": "1882–1941, England",
					"handle": "the-ghost-in-the-shell",
					"description": "Morning light on a dressing table, a window open to the river, the room half full of thought. The scent follows Woolf’s stream of consciousness, where identity flickers like reflections on water. On the skin it feels translucent and intimate, as though the self were always in motion. Softly modern, with a shimmer of melancholy."
				},
				{
					"item_title": "Gabriel García Márquez",
					"item_subtitle": "1927–2014, Colombia",
					"handle": "tropical",
					"description": "A courtyard after rain, fruit split open on a table, the air thick with heat and memory. It belongs to García Márquez’s world of abundance and enchantment, where the everyday suddenly tilts into myth. Wearing it feels lush and cinematic, as if you’re walking through a family story that has outgrown realism. Warm, vivid, and touched by miracle."
				},
				{
					"item_title": "Toni Morrison",
					"item_subtitle": "1931–2019, United States",
					"handle": "rose-riot",
					"description": "A velvet chair in a dark room, a single rose on the table, the air carrying both beauty and bruise. It speaks to Morrison’s power: tenderness braided with history, elegance standing beside pain. On the skin it feels dignified and alive, like entering a room and changing its temperature without raising your voice. Deeply human, with a pulse of red at the center."
				},
				{
					"item_title": "Marguerite Duras",
					"item_subtitle": "1914–1996, France",
					"handle": "rien",
					"description": "An empty hotel corridor, a cigarette fading in an ashtray, the sea somewhere beyond the walls. The scent matches Duras’s severe, hypnotic landscapes, where desire and absence keep trading places. Wearing it feels bare and magnetic, like speaking in a low voice and knowing everyone will lean in. Stark, intimate, and unforgettable."
				},
				{
					"item_title": "Octavio Paz",
					"item_subtitle": "1914–1998, Mexico",
					"handle": "spice-must-flow",
					"description": "A market at noon, cloth awnings lifting in hot air, spices dusting the light. It suits Paz’s restless mind, always moving between body, ritual, and thought. On the skin it feels bright and charged, like language that has just caught fire. A fragrance of argument, poetry, and heat."
				},
				{
					"item_title": "Clarice Lispector",
					"item_subtitle": "1920–1977, Brazil",
					"handle": "dawn-whispers",
					"description": "A white room before anyone speaks, sunlight on a glass, the smallest movement suddenly enormous. It reflects Lispector’s inward intensity, where consciousness turns a spoon, a hand, a silence into revelation. Wearing it feels private and electric, as if you were meeting yourself for the first time. Nearly weightless, but impossible to ignore."
				},
				{
					"item_title": "Rainer Maria Rilke",
					"item_subtitle": "1875–1926, Bohemia / Austria",
					"handle": "myrrhiad",
					"description": "A chapel after the candles have gone out, the last trace of smoke hanging in the air. It carries Rilke’s devotion to inwardness, to beauty that feels touched by prayer and solitude. On the skin it feels grave and tender, as if you were walking through a poem at dusk. A scent for longing that has learned discipline."
				},
				{
					"item_title": "Naguib Mahfouz",
					"item_subtitle": "1911–2006, Egypt",
					"handle": "marrakech-cologne",
					"description": "An old street at sunset, mint tea on a tray, stone walls holding the day’s heat. It fits Mahfouz’s patient cityscapes, where lives unfold in courtyards, cafés, and family rooms with quiet precision. Wearing it feels grounded and observant, like being part of a neighborhood that remembers everything. Clear-eyed, warm, and full of lived-in detail."
				},
				{
					"item_title": "Wisława Szymborska",
					"item_subtitle": "1923–2012, Poland",
					"handle": "you-or-someone-like-you",
					"description": "A bicycle leaning against a wall, mint on the fingers, a notebook open to a question that refuses to close. The scent has Szymborska’s lightness and wit, that gift for making the ordinary suddenly strange and exact. On the skin it feels brisk, intelligent, and a little sly, like a smile delivered mid-thought. Effortless on the surface, with a mind working underneath."
				},
				{
					"item_title": "Sappho",
					"item_subtitle": "c. 630–c. 570 BCE, Greece",
					"handle": "rose-omeyyade",
					"description": "Petals scattered on a stone step, the sea bright beyond the island edge. It belongs to Sappho’s world of ardor and lyric brevity, where desire arrives as image before it becomes explanation. Wearing it feels open-hearted and glowing, as if your own pulse had found a chorus. A rose with sunlight on it."
				},
				{
					"item_title": "Rabindranath Tagore",
					"item_subtitle": "1861–1941, India",
					"handle": "ta-if",
					"description": "A garden at evening, jasmine drifting through warm air, a lamp being lit behind a lattice window. It suits Tagore’s music of tenderness, spirituality, and human warmth. On the skin it feels expansive and graceful, like stepping into a song you already know by heart. Rich, luminous, and quietly reverent."
				}
			]
		}
	}
};
